import React, { useEffect, useState } from "react";
import { api } from "../api/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import MailModal from "../components/MailModal";
import WerbungModal from "../components/WerbungModal";
import BetriebsurlaubModal from "../components/BetriebsurlaubModal";
import FahrerKarte from "../components/FahrerKarte";

function ManuelleBestellungModal({ produkte, onClose, onSuccess }) {
  const leer = {
    name: "", email: "", telefon: "",
    produktId: "", menge: 1, intervall: "Einzelbestellung",
    lieferDatum: new Date().toISOString().slice(0,10),
    strasse: "", hausnummer: "", plz: "", ort: "",
    notiz: "", zahlungsMethode: "Rechnung"
  };
  const [form,    setForm]    = useState(leer);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);
  const [success, setSuccess] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.produktId || !form.lieferDatum) {
      setError("Bitte Name, Produkt und Datum ausfüllen."); return;
    }
    setLoading(true); setError(null);
    try {
      await api.manuelleBestellung.create({ ...form, produktId: parseInt(form.produktId), menge: parseFloat(form.menge) });
      setSuccess(true);
      setTimeout(onSuccess, 1200);
    } catch (err) {
      setError("Fehler beim Speichern.");
    } finally { setLoading(false); }
  };

  const gew = produkte.find(p => p.produktId === parseInt(form.produktId));

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div style={{ background: "white", borderRadius: "14px", padding: "1.75rem", maxWidth: 600, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 40px rgba(0,0,0,0.2)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ color: "#2e7d32", margin: 0 }}>📞 Manuelle Bestellung</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: "1.4rem", cursor: "pointer", color: "#aaa" }}>✕</button>
        </div>

        {success && <div className="alert alert-success">✓ Bestellung + Rechnung erstellt!</div>}
        {error   && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          {/* Kundendaten */}
          <p style={{ fontWeight: 600, color: "#555", marginBottom: "0.75rem", fontSize: "0.9rem" }}>👤 Kundendaten</p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 1rem" }}>
            <div className="form-group" style={{ gridColumn: "1/-1" }}>
              <label>Name *</label>
              <input value={form.name} onChange={e => set("name", e.target.value)} placeholder="Vor- und Nachname" required />
            </div>
            <div className="form-group">
              <label>Telefon</label>
              <input value={form.telefon} onChange={e => set("telefon", e.target.value)} placeholder="0531 123456" />
            </div>
            <div className="form-group">
              <label>E-Mail</label>
              <input type="email" value={form.email} onChange={e => set("email", e.target.value)} placeholder="optional" />
            </div>
          </div>

          {/* Lieferadresse */}
          <p style={{ fontWeight: 600, color: "#555", margin: "0.5rem 0 0.75rem", fontSize: "0.9rem" }}>📍 Lieferadresse</p>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>Straße</label>
              <input value={form.strasse} onChange={e => set("strasse", e.target.value)} placeholder="Musterstraße" />
            </div>
            <div className="form-group">
              <label>Hausnummer</label>
              <input value={form.hausnummer} onChange={e => set("hausnummer", e.target.value)} placeholder="12a" />
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>PLZ</label>
              <input value={form.plz} onChange={e => set("plz", e.target.value)} placeholder="38350" />
            </div>
            <div className="form-group">
              <label>Ort</label>
              <input value={form.ort} onChange={e => set("ort", e.target.value)} placeholder="Helmstedt" />
            </div>
          </div>

          {/* Bestellung */}
          <p style={{ fontWeight: 600, color: "#555", margin: "0.5rem 0 0.75rem", fontSize: "0.9rem" }}>🛒 Bestellung</p>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>Produkt *</label>
              <select value={form.produktId} onChange={e => set("produktId", e.target.value)} required>
                <option value="">– Produkt wählen –</option>
                {produkte.filter(p => p.istVerfuegbar).map(p => (
                  <option key={p.produktId} value={p.produktId}>{p.name} – {p.preis.toFixed(2)} €/{p.einheit}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Menge *</label>
              <input type="number" min="0.5" step="0.5" value={form.menge}
                onChange={e => set("menge", e.target.value)} />
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>Intervall</label>
              <select value={form.intervall} onChange={e => set("intervall", e.target.value)}>
                <option value="Einzelbestellung">Einzelbestellung</option>
                <option value="Wöchentlich">Wöchentlich</option>
                <option value="2-wöchentlich">2-wöchentlich</option>
                <option value="Monatlich">Monatlich</option>
              </select>
            </div>
            <div className="form-group">
              <label>Lieferdatum *</label>
              <input type="date" value={form.lieferDatum} onChange={e => set("lieferDatum", e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Zahlungsart</label>
              <select value={form.zahlungsMethode} onChange={e => set("zahlungsMethode", e.target.value)}>
                <option value="Rechnung">Rechnung</option>
                <option value="Bar">Bar</option>
                <option value="Überweisung">Überweisung</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>Notiz</label>
            <textarea rows={2} value={form.notiz} onChange={e => set("notiz", e.target.value)} placeholder="z.B. Klingelt nicht, bitte anrufen" />
          </div>

          {/* Preis-Vorschau */}
          {gew && (
            <div style={{ background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "8px", padding: "0.75rem 1rem", marginBottom: "1rem", fontSize: "0.95rem" }}>
              💰 Gesamtpreis: <strong style={{ color: "#2e7d32" }}>{(gew.preis * parseFloat(form.menge || 0)).toFixed(2)} €</strong>
              <span style={{ color: "#888", fontSize: "0.85rem", marginLeft: "0.5rem" }}>· Rechnung fällig in 14 Tagen</span>
            </div>
          )}

          <div style={{ display: "flex", gap: "0.75rem" }}>
            <button className="btn btn-success" type="submit" disabled={loading} style={{ flex: 1 }}>
              {loading ? "⏳ Wird gespeichert..." : "✓ Bestellung + Rechnung erstellen"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ── Manuelles Abo anlegen ─────────────────────────────────
function ManuellesAboModal({ produkte, onClose, onSuccess }) {
  const leer = {
    userId: "", produktId: "", menge: 1, intervall: "Wöchentlich",
    startDatum: new Date().toISOString().slice(0,10),
    strasse: "", hausnummer: "", plz: "", ort: "", notiz: "",
  };
  const [form,    setForm]    = useState(leer);
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/auth/users")
      .then(r => r.json()).then(setUsers).catch(() => {});
  }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const gewProd = produkte.find(p => p.produktId === parseInt(form.produktId));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.userId || !form.produktId) { setError("Kunde und Produkt auswählen."); return; }
    setLoading(true); setError(null);
    try {
      await api.abos.create({
        userId:     parseInt(form.userId),
        produktId:  parseInt(form.produktId),
        menge:      parseFloat(form.menge),
        intervall:  form.intervall,
        startDatum: form.startDatum,
        strasse:    form.strasse    || null,
        hausnummer: form.hausnummer || null,
        plz:        form.plz        || null,
        ort:        form.ort        || null,
        notiz:      form.notiz      || null,
      });
      setSuccess(true);
      setTimeout(onSuccess, 1200);
    } catch (err) {
      setError(err.message || "Fehler beim Erstellen.");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div style={{ background: "white", borderRadius: "14px", padding: "1.75rem", maxWidth: 600, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 40px rgba(0,0,0,0.2)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ color: "#2e7d32", margin: 0 }}>📦 Manuelles Abo anlegen</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: "1.4rem", cursor: "pointer", color: "#aaa" }}>✕</button>
        </div>

        {success && <div className="alert alert-success">✓ Abo wurde angelegt!</div>}
        {error   && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          {/* Kunde */}
          <p style={{ fontWeight: 600, color: "#555", marginBottom: "0.75rem", fontSize: "0.9rem" }}>👤 Kunde</p>
          <div className="form-group">
            <label>Kunde *</label>
            <select value={form.userId} onChange={e => set("userId", e.target.value)} required>
              <option value="">– Kunden auswählen –</option>
              {users.sort((a,b) => (a.nachname ?? "").localeCompare(b.nachname ?? "")).map(u => (
                <option key={u.userId} value={u.userId}>{u.nachname}, {u.vorname} ({u.email})</option>
              ))}
            </select>
          </div>

          {/* Produkt + Menge + Intervall */}
          <p style={{ fontWeight: 600, color: "#555", margin: "0.5rem 0 0.75rem", fontSize: "0.9rem" }}>🥛 Abo-Details</p>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>Produkt *</label>
              <select value={form.produktId} onChange={e => set("produktId", e.target.value)} required>
                <option value="">– Produkt wählen –</option>
                {produkte.filter(p => p.istVerfuegbar).map(p => (
                  <option key={p.produktId} value={p.produktId}>{p.name} – {p.preis.toFixed(2)} €/{p.einheit}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Menge *</label>
              <input type="number" min="0.5" step="0.5" value={form.menge}
                onChange={e => set("menge", e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Intervall *</label>
              <select value={form.intervall} onChange={e => set("intervall", e.target.value)}>
                <option value="Wöchentlich">Wöchentlich</option>
                <option value="2-wöchentlich">2-wöchentlich</option>
                <option value="Monatlich">Monatlich</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>Startdatum *</label>
            <input type="date" value={form.startDatum} onChange={e => set("startDatum", e.target.value)} required />
          </div>

          {/* Lieferadresse */}
          <p style={{ fontWeight: 600, color: "#555", margin: "0.5rem 0 0.75rem", fontSize: "0.9rem" }}>📍 Lieferadresse</p>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>Straße</label>
              <input value={form.strasse} onChange={e => set("strasse", e.target.value)} placeholder="Musterstraße" />
            </div>
            <div className="form-group">
              <label>Hausnummer</label>
              <input value={form.hausnummer} onChange={e => set("hausnummer", e.target.value)} placeholder="12a" />
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>PLZ</label>
              <input value={form.plz} onChange={e => set("plz", e.target.value)} placeholder="38350" />
            </div>
            <div className="form-group">
              <label>Ort</label>
              <input value={form.ort} onChange={e => set("ort", e.target.value)} placeholder="Helmstedt" />
            </div>
          </div>
          <div className="form-group">
            <label>Notiz</label>
            <input value={form.notiz} onChange={e => set("notiz", e.target.value)}
              placeholder='z.B. "Abholung" oder Hinweis für den Fahrer' />
          </div>

          {/* Preis-Vorschau */}
          {gewProd && (
            <div style={{ background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "8px", padding: "0.75rem 1rem", marginBottom: "1rem", fontSize: "0.95rem" }}>
              💰 Preis pro Lieferung: <strong style={{ color: "#2e7d32" }}>{(gewProd.preis * parseFloat(form.menge || 0)).toFixed(2)} €</strong>
              <span style={{ color: "#888", fontSize: "0.85rem", marginLeft: "0.5rem" }}>· Zahlungsart: Rechnung</span>
            </div>
          )}

          <div style={{ display: "flex", gap: "0.75rem" }}>
            <button className="btn btn-success" type="submit" disabled={loading} style={{ flex: 1 }}>
              {loading ? "⏳ Wird angelegt..." : "✓ Abo anlegen"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ── CAMT Import ───────────────────────────────────────────
function CamtImportButton({ onSuccess }) {
  const [offen,   setOffen]   = useState(false);
  const [datei,   setDatei]   = useState(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);
  const [result,  setResult]  = useState(null); // { zugeordnet, nichtZugeordnet }

  const handleUpload = async () => {
    if (!datei) { setError("Bitte eine CAMT-XML-Datei auswählen."); return; }
    setLoading(true); setError(null); setResult(null);
    try {
      const fd = new FormData();
      fd.append("datei", datei);
      const res = await api.rechnungen.camtImport(fd);
      setResult(res);
      if (res.zugeordnet?.length > 0) onSuccess?.();
    } catch (e) {
      setError(e.message || "Fehler beim Import.");
    } finally { setLoading(false); }
  };

  const handleClose = () => { setOffen(false); setDatei(null); setError(null); setResult(null); };

  return (
    <>
      <button className="btn" onClick={() => setOffen(true)}
        style={{ background: "#00695c", color: "white", padding: "0.35rem 1rem", fontSize: "0.88rem" }}>
        🏦 CAMT importieren
      </button>

      {offen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
          <div style={{ background: "white", borderRadius: "16px", padding: "2rem", width: "100%", maxWidth: 620, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 40px rgba(0,0,0,0.2)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
              <h3 style={{ color: "#00695c", margin: 0 }}>🏦 CAMT-Datei importieren</h3>
              <button onClick={handleClose} style={{ background: "none", border: "none", fontSize: "1.4rem", cursor: "pointer", color: "#888" }}>×</button>
            </div>

            {!result ? (
              <>
                <p style={{ color: "#555", marginBottom: "1.25rem", fontSize: "0.95rem" }}>
                  Lade deine CAMT.053-Datei hoch. Eingehende Überweisungen werden automatisch mit offenen Rechnungen abgeglichen und als <strong>Bezahlt</strong> markiert.
                </p>
                <div className="form-group">
                  <label>CAMT-Datei (.xml)</label>
                  <input type="file" accept=".xml" onChange={e => { setDatei(e.target.files[0]); setError(null); }} />
                </div>
                {error && <div className="alert alert-error" style={{ marginBottom: "1rem" }}>{error}</div>}
                <button className="btn btn-success" onClick={handleUpload} disabled={loading || !datei}
                  style={{ width: "100%", marginTop: "0.5rem" }}>
                  {loading ? "⏳ Wird verarbeitet..." : "📤 Importieren & abgleichen"}
                </button>
              </>
            ) : (
              <>
                {/* Zugeordnet */}
                <div style={{ marginBottom: "1.5rem" }}>
                  <h4 style={{ color: "#2e7d32", marginBottom: "0.75rem" }}>
                    ✓ Automatisch zugeordnet ({result.zugeordnet?.length ?? 0})
                  </h4>
                  {result.zugeordnet?.length > 0 ? (
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.88rem" }}>
                      <thead>
                        <tr style={{ background: "#e8f5e9" }}>
                          <th style={TH}>Rechnung</th><th style={TH}>Kunde</th><th style={TH}>Betrag</th><th style={TH}>Datum</th><th style={TH}>Verwendungszweck</th>
                        </tr>
                      </thead>
                      <tbody>
                        {result.zugeordnet.map((z, i) => (
                          <tr key={i} style={{ borderBottom: "1px solid #e0e0e0" }}>
                            <td style={TD}>#{z.rechnungId}</td>
                            <td style={TD}>{z.kundenName}</td>
                            <td style={TD}><strong>{z.betrag?.toFixed(2)} €</strong></td>
                            <td style={TD}>{z.buchungsDatum}</td>
                            <td style={{ ...TD, color: "#555", fontSize: "0.82rem", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                              title={z.verwendungszweck}>{z.verwendungszweck || "–"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p style={{ color: "#888", fontSize: "0.9rem" }}>Keine Rechnungen zugeordnet.</p>
                  )}
                </div>

                {/* Nicht zugeordnet */}
                {result.nichtZugeordnet?.length > 0 && (
                  <div>
                    <h4 style={{ color: "#e65100", marginBottom: "0.75rem" }}>
                      ⚠️ Nicht zugeordnet ({result.nichtZugeordnet.length})
                    </h4>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.88rem" }}>
                      <thead>
                        <tr style={{ background: "#fff3e0" }}>
                          <th style={TH}>Betrag</th><th style={TH}>Zahler</th><th style={TH}>Datum</th><th style={TH}>Verwendungszweck</th>
                        </tr>
                      </thead>
                      <tbody>
                        {result.nichtZugeordnet.map((n, i) => (
                          <tr key={i} style={{ borderBottom: "1px solid #e0e0e0" }}>
                            <td style={TD}><strong>{n.betrag?.toFixed(2)} €</strong></td>
                            <td style={TD}>{n.zahler || "–"}</td>
                            <td style={TD}>{n.buchungsDatum}</td>
                            <td style={{ ...TD, color: "#555", fontSize: "0.82rem", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                              title={n.verwendungszweck}>{n.verwendungszweck || "–"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {result.hinweis && <p style={{ color: "#888", marginTop: "1rem" }}>{result.hinweis}</p>}

                <button className="btn btn-secondary" onClick={handleClose} style={{ width: "100%", marginTop: "1.5rem" }}>
                  Schließen
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
const TH = { padding: "0.5rem 0.75rem", textAlign: "left", fontWeight: 600 };
const TD = { padding: "0.5rem 0.75rem" };

// ── Manuelle Rechnung ─────────────────────────────────────
function ManuelleRechnungButton({ kunden, onSuccess }) {
  const [offen, setOffen] = useState(false);
  const [form, setForm] = useState({
    userId: "", beschreibung: "", menge: "1", einheit: "Stk.",
    betrag: "", faelligAm: new Date(Date.now() + 14*86400000).toISOString().slice(0,10),
    strasse: "", plz: "", ort: "", sendMail: false,
  });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  // Eindeutige Kunden aus Bestellungen
  const kundenListe = kunden
    ? [...new Map(kunden.map(b => [b.userId, b])).values()].sort((a,b) => a.nachname?.localeCompare(b.nachname))
    : [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!form.userId)       { setError("Bitte Kunden auswählen."); return; }
    if (!form.beschreibung) { setError("Beschreibung fehlt."); return; }
    if (!form.betrag || isNaN(parseFloat(form.betrag))) { setError("Betrag fehlt."); return; }
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/rechnungen/manuell`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId:       parseInt(form.userId),
          beschreibung: form.beschreibung,
          menge:        parseFloat(form.menge) || 1,
          einheit:      form.einheit,
          betrag:       parseFloat(form.betrag),
          faelligAm:    form.faelligAm,
          sendMail:     form.sendMail,
          strasse:      form.strasse || null,
          plz:          form.plz || null,
          ort:          form.ort || null,
        }),
      });
      if (!response.ok) { setError("Fehler beim Erstellen."); setLoading(false); return; }
      // PDF direkt herunterladen
      const blob = await response.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href = url; a.download = "Rechnung.pdf"; a.click();
      URL.revokeObjectURL(url);
      setOffen(false);
      setForm({ userId: "", beschreibung: "", menge: "1", einheit: "Stk.", betrag: "", faelligAm: new Date(Date.now() + 14*86400000).toISOString().slice(0,10), strasse: "", plz: "", ort: "", sendMail: false });
      onSuccess?.();
    } catch { setError("Netzwerkfehler."); }
    finally { setLoading(false); }
  };

  // Adresse auto-füllen wenn Kunde gewählt
  const handleKundeWahl = (userId) => {
    const k = kunden?.find(b => String(b.userId) === userId);
    setForm(f => ({
      ...f,
      userId,
      strasse: k?.strasse ?? "",
      plz:     k?.plz     ?? "",
      ort:     k?.ort     ?? "",
    }));
  };

  return (
    <>
      <button className="btn" onClick={() => setOffen(true)}
        style={{ background: "#1565c0", color: "white", padding: "0.35rem 1rem", fontSize: "0.88rem" }}>
        ✏️ Manuelle Rechnung
      </button>

      {offen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
          <div style={{ background: "white", borderRadius: "16px", padding: "2rem", width: "100%", maxWidth: 560, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 40px rgba(0,0,0,0.2)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
              <h3 style={{ color: "#1565c0", margin: 0 }}>✏️ Manuelle Rechnung erstellen</h3>
              <button onClick={() => setOffen(false)} style={{ background: "none", border: "none", fontSize: "1.4rem", cursor: "pointer", color: "#888" }}>×</button>
            </div>

            {error && <div className="alert alert-error" style={{ marginBottom: "1rem" }}>{error}</div>}

            <form onSubmit={handleSubmit}>
              {/* Kunde */}
              <div className="form-group">
                <label>Kunde *</label>
                <select value={form.userId} onChange={e => handleKundeWahl(e.target.value)} required>
                  <option value="">– Kunden auswählen –</option>
                  {kundenListe.map(k => (
                    <option key={k.userId} value={k.userId}>
                      {k.nachname}, {k.vorname} ({k.email})
                    </option>
                  ))}
                </select>
              </div>

              {/* Beschreibung */}
              <div className="form-group">
                <label>Beschreibung / Leistung *</label>
                <input value={form.beschreibung} onChange={e => setForm({...form, beschreibung: e.target.value})}
                  placeholder="z.B. Sonderlieferung, Pfand-Nachberechnung, Beratung..." required />
              </div>

              {/* Menge + Einheit + Betrag */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 1rem" }}>
                <div className="form-group">
                  <label>Menge</label>
                  <input type="number" min="0.01" step="0.01" value={form.menge}
                    onChange={e => setForm({...form, menge: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Einheit</label>
                  <input value={form.einheit} onChange={e => setForm({...form, einheit: e.target.value})}
                    placeholder="Stk., h, km..." />
                </div>
                <div className="form-group">
                  <label>Betrag (€) *</label>
                  <input type="number" min="0.01" step="0.01" value={form.betrag}
                    onChange={e => setForm({...form, betrag: e.target.value})} required />
                </div>
              </div>

              {/* Fällig am */}
              <div className="form-group">
                <label>Fällig am *</label>
                <input type="date" value={form.faelligAm} onChange={e => setForm({...form, faelligAm: e.target.value})} required />
              </div>

              {/* Adresse (auto-gefüllt, editierbar) */}
              <p style={{ fontWeight: 600, color: "#555", margin: "0.5rem 0 0.25rem" }}>📍 Adresse (optional, erscheint im PDF)</p>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 100px", gap: "0 1rem" }}>
                <div className="form-group">
                  <label>Straße</label>
                  <input value={form.strasse} onChange={e => setForm({...form, strasse: e.target.value})} placeholder="Musterstraße 1" />
                </div>
                <div className="form-group">
                  <label>PLZ</label>
                  <input value={form.plz} onChange={e => setForm({...form, plz: e.target.value})} placeholder="12345" />
                </div>
              </div>
              <div className="form-group">
                <label>Ort</label>
                <input value={form.ort} onChange={e => setForm({...form, ort: e.target.value})} placeholder="Musterstadt" />
              </div>

              {/* Vorschau */}
              {form.betrag && !isNaN(parseFloat(form.betrag)) && (
                <div style={{ background: "#f1f8e9", border: "1px solid #a5d6a7", borderRadius: "8px", padding: "0.75rem 1rem", marginBottom: "1rem", fontSize: "0.92rem" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>{form.beschreibung || "Leistung"} ({form.menge} {form.einheit})</span>
                    <strong style={{ color: "#2e7d32" }}>{parseFloat(form.betrag).toFixed(2)} €</strong>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.82rem", color: "#888", marginTop: "0.3rem" }}>
                    <span>Fällig: {form.faelligAm ? new Date(form.faelligAm + "T00:00:00").toLocaleDateString("de-DE") : "–"}</span>
                    <span>Status: Offen</span>
                  </div>
                </div>
              )}

              {/* Mail senden */}
              <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem", cursor: "pointer", fontSize: "0.9rem" }}>
                <input type="checkbox" checked={form.sendMail} onChange={e => setForm({...form, sendMail: e.target.checked})} />
                ✉️ Rechnung direkt per E-Mail an Kunden senden
              </label>

              <div style={{ display: "flex", gap: "0.75rem" }}>
                <button type="submit" className="btn" disabled={loading}
                  style={{ background: "#1565c0", color: "white", flex: 1 }}>
                  {loading ? "⏳ Wird erstellt..." : "📄 Rechnung erstellen & PDF herunterladen"}
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => setOffen(false)}>Abbrechen</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

function AnalyseTab({ analyse }) {
  if (!analyse) return <div style={{ padding: "2rem", textAlign: "center", color: "#aaa" }}>Lädt...</div>;
  const { kpis, monatlich, topProdukte, intervalle } = analyse;

  const maxUmsatz = Math.max(...monatlich.map(m => m.umsatz), 1);
  const maxBestellungen = Math.max(...monatlich.map(m => m.anzahlBestellungen), 1);

  const monatName = (str) => {
    const [y, m] = str.split("-");
    return new Date(y, m - 1).toLocaleDateString("de-DE", { month: "short", year: "2-digit" });
  };

  const kpiCards = [
    { label: "Kunden gesamt",        value: kpis.totalKunden,             icon: "👥", color: "#1565c0", bg: "#e3f2fd" },
    { label: "Aktive Abos",          value: kpis.aktiveAbos,              icon: "📦", color: "#2e7d32", bg: "#e8f5e9" },
    { label: "Monatl. Umsatz (ca.)", value: `${kpis.monatlicherUmsatz.toFixed(2)} €`, icon: "💶", color: "#e65100", bg: "#fff3e0" },
    { label: "Bestellungen (Monat)", value: kpis.bestellungenDieserMonat, icon: "📋", color: "#6a1b9a", bg: "#f3e5f5" },
    { label: "Ungelesene Nachr.",    value: kpis.ungelNachrichten,        icon: "✉️", color: "#0277bd", bg: "#e1f5fe" },
    { label: "Offene Besichtigungen",value: kpis.offeneBesichtigungen,    icon: "🐄", color: "#558b2f", bg: "#f1f8e9" },
  ];

  return (
    <div style={{ marginTop: "1rem" }}>
      {/* ── KPI Cards ── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1rem", marginBottom: "2rem" }}>
        {kpiCards.map(k => (
          <div key={k.label} className="card" style={{ background: k.bg, border: `1.5px solid ${k.color}22`, textAlign: "center", padding: "1.25rem" }}>
            <div style={{ fontSize: "2rem" }}>{k.icon}</div>
            <div style={{ fontSize: "1.8rem", fontWeight: 700, color: k.color, lineHeight: 1.2 }}>{k.value}</div>
            <div style={{ color: "#666", fontSize: "0.85rem", marginTop: "0.25rem" }}>{k.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.5rem" }}>
        {/* ── Umsatz Chart ── */}
        <div className="card">
          <h3 style={{ color: "#e65100", marginBottom: "1rem" }}>💶 Umsatz pro Monat (ca.)</h3>
          {monatlich.length === 0
            ? <p style={{ color: "#aaa", textAlign: "center" }}>Noch keine Daten.</p>
            : (
              <div style={{ display: "flex", alignItems: "flex-end", gap: "6px", height: 160 }}>
                {monatlich.map(m => (
                  <div key={m.monat} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                    <div style={{ fontSize: "0.65rem", color: "#e65100", fontWeight: 600 }}>
                      {m.umsatz > 0 ? `${m.umsatz.toFixed(0)}€` : ""}
                    </div>
                    <div style={{
                      width: "100%", borderRadius: "4px 4px 0 0",
                      background: "linear-gradient(to top, #e65100, #ff9800)",
                      height: `${Math.max((m.umsatz / maxUmsatz) * 120, m.umsatz > 0 ? 4 : 0)}px`,
                      transition: "height 0.3s"
                    }} title={`${monatName(m.monat)}: ${m.umsatz.toFixed(2)} €`} />
                    <div style={{ fontSize: "0.65rem", color: "#888", writingMode: "vertical-rl", transform: "rotate(180deg)", height: 30 }}>
                      {monatName(m.monat)}
                    </div>
                  </div>
                ))}
              </div>
            )
          }
        </div>

        {/* ── Bestellungen Chart ── */}
        <div className="card">
          <h3 style={{ color: "#1565c0", marginBottom: "1rem" }}>📋 Bestellungen pro Monat</h3>
          {monatlich.length === 0
            ? <p style={{ color: "#aaa", textAlign: "center" }}>Noch keine Daten.</p>
            : (
              <div style={{ display: "flex", alignItems: "flex-end", gap: "6px", height: 160 }}>
                {monatlich.map(m => (
                  <div key={m.monat} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                    <div style={{ fontSize: "0.65rem", color: "#1565c0", fontWeight: 600 }}>
                      {m.anzahlBestellungen > 0 ? m.anzahlBestellungen : ""}
                    </div>
                    <div style={{
                      width: "100%", borderRadius: "4px 4px 0 0",
                      background: "linear-gradient(to top, #1565c0, #42a5f5)",
                      height: `${Math.max((m.anzahlBestellungen / maxBestellungen) * 120, m.anzahlBestellungen > 0 ? 4 : 0)}px`,
                      transition: "height 0.3s"
                    }} title={`${monatName(m.monat)}: ${m.anzahlBestellungen} Bestellungen`} />
                    <div style={{ fontSize: "0.65rem", color: "#888", writingMode: "vertical-rl", transform: "rotate(180deg)", height: 30 }}>
                      {monatName(m.monat)}
                    </div>
                  </div>
                ))}
              </div>
            )
          }
        </div>

        {/* ── Top Produkte ── */}
        <div className="card">
          <h3 style={{ color: "#2e7d32", marginBottom: "1rem" }}>🏆 Top Produkte (aktive Abos)</h3>
          {topProdukte.length === 0
            ? <p style={{ color: "#aaa" }}>Noch keine Daten.</p>
            : topProdukte.map((p, i) => {
              const maxAbos = topProdukte[0].anzahlAbos;
              return (
                <div key={p.name} style={{ marginBottom: "0.75rem" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.9rem", marginBottom: "0.2rem" }}>
                    <span><strong style={{ color: "#2e7d32" }}>#{i+1}</strong> {p.name}</span>
                    <span style={{ color: "#888" }}>{p.anzahlAbos} Abos · {p.gesamtMenge} {p.einheit}</span>
                  </div>
                  <div style={{ height: 8, background: "#e8f5e9", borderRadius: 4, overflow: "hidden" }}>
                    <div style={{ height: "100%", background: "linear-gradient(to right, #2e7d32, #66bb6a)", borderRadius: 4, width: `${(p.anzahlAbos / maxAbos) * 100}%` }} />
                  </div>
                </div>
              );
            })
          }
        </div>

        {/* ── Intervall Verteilung ── */}
        <div className="card">
          <h3 style={{ color: "#6a1b9a", marginBottom: "1rem" }}>🔄 Intervall-Verteilung</h3>
          {intervalle.length === 0
            ? <p style={{ color: "#aaa" }}>Noch keine Daten.</p>
            : intervalle.map(iv => {
              const total = intervalle.reduce((s, x) => s + x.anzahl, 0);
              const pct   = Math.round((iv.anzahl / total) * 100);
              return (
                <div key={iv.intervall} style={{ marginBottom: "0.75rem" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.9rem", marginBottom: "0.2rem" }}>
                    <span>{iv.intervall}</span>
                    <span style={{ color: "#888" }}>{iv.anzahl} ({pct}%)</span>
                  </div>
                  <div style={{ height: 8, background: "#f3e5f5", borderRadius: 4, overflow: "hidden" }}>
                    <div style={{ height: "100%", background: "linear-gradient(to right, #6a1b9a, #ce93d8)", borderRadius: 4, width: `${pct}%` }} />
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </div>
  );
}

function EventsTab({ events, setEvents }) {
  const leer = { titel: "", beschreibung: "", datum: "", uhrzeit: "", ort: "" };
  const [form,    setForm]    = useState(leer);
  const [success, setSuccess] = useState(false);
  const [error,   setError]   = useState(null);

  const handleCreate = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await api.events.create(form);
      setSuccess(true);
      setForm(leer);
      api.events.getAll().then(setEvents);
    } catch { setError("Fehler beim Erstellen."); }
  };

  const toggleAktiv = async (id, val) => {
    await api.events.toggleAktiv(id, val);
    setEvents(prev => prev.map(e => e.eventId === id ? { ...e, istAktiv: val } : e));
  };

  const del = async (id) => {
    if (!window.confirm("Event wirklich löschen?")) return;
    await api.events.delete(id);
    setEvents(prev => prev.filter(e => e.eventId !== id));
  };

  const vergangen = (datum) => new Date(datum + "T00:00:00") < new Date(new Date().toDateString());

  return (
    <div style={{ marginTop: "1rem" }}>
      {/* ── Neues Event ── */}
      <div className="card" style={{ border: "1.5px solid #ffe0b2", marginBottom: "1.5rem" }}>
        <h3 style={{ color: "#e65100", marginBottom: "1rem" }}>🎉 Neues Event erstellen</h3>
        {success && <div className="alert alert-success">✓ Event erstellt!</div>}
        {error   && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleCreate}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 1rem" }}>
            <div className="form-group" style={{ gridColumn: "1 / -1" }}>
              <label>Titel *</label>
              <input value={form.titel} required
                onChange={e => setForm({ ...form, titel: e.target.value })}
                placeholder="z.B. Tag der offenen Tür" />
            </div>
            <div className="form-group">
              <label>Datum *</label>
              <input type="date" value={form.datum} required min={new Date().toISOString().slice(0,10)}
                onChange={e => setForm({ ...form, datum: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Uhrzeit</label>
              <input type="time" value={form.uhrzeit}
                onChange={e => setForm({ ...form, uhrzeit: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Ort</label>
              <input value={form.ort}
                onChange={e => setForm({ ...form, ort: e.target.value })}
                placeholder="z.B. Scheune, Milchhof" />
            </div>
            <div className="form-group" style={{ gridColumn: "1 / -1" }}>
              <label>Beschreibung</label>
              <textarea rows={2} value={form.beschreibung}
                onChange={e => setForm({ ...form, beschreibung: e.target.value })}
                placeholder="z.B. Kommt vorbei und lernt unseren Hof kennen!" />
            </div>
          </div>
          <button className="btn" type="submit"
            style={{ background: "#e65100", color: "white" }}>
            ➕ Event erstellen
          </button>
        </form>
      </div>

      {/* ── Übersicht ── */}
      <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        {events.length === 0 && (
          <div className="card" style={{ textAlign: "center", color: "#aaa" }}>Noch keine Events.</div>
        )}
        {events.map(e => {
          const verg = vergangen(e.datum);
          return (
            <div key={e.eventId} className="card" style={{
              border: `1.5px solid ${e.istAktiv && !verg ? "#ffcc80" : "#e0e0e0"}`,
              opacity: verg || !e.istAktiv ? 0.6 : 1,
              display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "1rem"
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap" }}>
                  <strong style={{ color: "#e65100", fontSize: "1.05rem" }}>{e.titel}</strong>
                  {verg && <span className="badge" style={{ background: "#f5f5f5", color: "#999" }}>Vergangen</span>}
                  {!e.istAktiv && <span className="badge" style={{ background: "#ffebee", color: "#c62828" }}>Versteckt</span>}
                  {e.istAktiv && !verg && <span className="badge" style={{ background: "#e8f5e9", color: "#2e7d32" }}>✓ Sichtbar</span>}
                </div>
                <div style={{ color: "#555", fontSize: "0.9rem", marginTop: "0.3rem" }}>
                  📅 {new Date(e.datum + "T00:00:00").toLocaleDateString("de-DE", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
                  {e.uhrzeit && ` · 🕐 ${e.uhrzeit} Uhr`}
                  {e.ort     && ` · 📍 ${e.ort}`}
                </div>
                {e.beschreibung && <p style={{ color: "#777", fontSize: "0.88rem", marginTop: "0.3rem" }}>{e.beschreibung}</p>}
              </div>
              <div style={{ display: "flex", gap: "0.5rem", flexShrink: 0 }}>
                <button className={`btn ${e.istAktiv ? "btn-secondary" : "btn-success"}`}
                  style={{ padding: "0.3rem 0.7rem", fontSize: "0.8rem" }}
                  onClick={() => toggleAktiv(e.eventId, !e.istAktiv)}>
                  {e.istAktiv ? "Verstecken" : "Anzeigen"}
                </button>
                <button style={{ padding: "0.3rem 0.7rem", fontSize: "0.8rem", background: "none", border: "1px solid #ffcdd2", borderRadius: "6px", cursor: "pointer", color: "#c62828" }}
                  onClick={() => del(e.eventId)}>
                  🗑️
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function RabattcodesTab({ rabattcodes, setRabattcodes }) {
  const leer = { code: "", beschreibung: "", typRabatt: "Prozent", wert: "", mindestBestellwert: "", maxNutzungen: "", gueltigVon: "", gueltigBis: "" };
  const [form,    setForm]    = useState(leer);
  const [success, setSuccess] = useState(false);
  const [error,   setError]   = useState(null);

  const handleCreate = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await api.rabattcodes.create({
        ...form,
        wert:               parseFloat(form.wert),
        mindestBestellwert: form.mindestBestellwert ? parseFloat(form.mindestBestellwert) : 0,
        maxNutzungen:       form.maxNutzungen ? parseInt(form.maxNutzungen) : null,
        gueltigVon:         form.gueltigVon || null,
        gueltigBis:         form.gueltigBis || null,
      });
      setSuccess(true);
      setForm(leer);
      api.rabattcodes.getAll().then(setRabattcodes);
    } catch { setError("Fehler – Code bereits vergeben?"); }
  };

  const toggleAktiv = async (id, val) => {
    await api.rabattcodes.toggleAktiv(id, val);
    setRabattcodes(prev => prev.map(r => r.rabattcodeId === id ? { ...r, istAktiv: val } : r));
  };

  const del = async (id) => {
    if (!window.confirm("Rabattcode wirklich löschen?")) return;
    await api.rabattcodes.delete(id);
    setRabattcodes(prev => prev.filter(r => r.rabattcodeId !== id));
  };

  const genCode = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    const code = Array.from({ length: 8 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
    setForm(f => ({ ...f, code }));
  };

  return (
    <div style={{ marginTop: "1rem" }}>
      {/* ── Neuen Code erstellen ── */}
      <div className="card" style={{ border: "1.5px solid #b3e5fc", marginBottom: "1.5rem" }}>
        <h3 style={{ color: "#0277bd", marginBottom: "1rem" }}>🏷️ Neuen Rabattcode erstellen</h3>
        {success && <div className="alert alert-success">✓ Rabattcode erstellt!</div>}
        {error   && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleCreate}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>Code *</label>
              <div style={{ display: "flex", gap: "0.4rem" }}>
                <input value={form.code} required
                  onChange={e => setForm({ ...form, code: e.target.value.toUpperCase() })}
                  placeholder="z.B. RABATT10" style={{ flex: 1 }} />
                <button type="button" onClick={genCode}
                  style={{ padding: "0 0.7rem", borderRadius: "8px", border: "1px solid #ccc", cursor: "pointer", background: "#e1f5fe", fontSize: "0.85rem" }}>
                  🎲
                </button>
              </div>
            </div>
            <div className="form-group">
              <label>Rabatt *</label>
              <div style={{ display: "flex", gap: "0.4rem" }}>
                <input type="number" min="0" step="0.01" value={form.wert} required
                  onChange={e => setForm({ ...form, wert: e.target.value })}
                  placeholder="10" style={{ flex: 1 }} />
                <select value={form.typRabatt} onChange={e => setForm({ ...form, typRabatt: e.target.value })}
                  style={{ width: 90 }}>
                  <option value="Prozent">%</option>
                  <option value="Betrag">€</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label>Mindestbestellwert (€)</label>
              <input type="number" min="0" step="0.01" value={form.mindestBestellwert}
                onChange={e => setForm({ ...form, mindestBestellwert: e.target.value })}
                placeholder="0 = kein Minimum" />
            </div>
            <div className="form-group">
              <label>Beschreibung</label>
              <input value={form.beschreibung}
                onChange={e => setForm({ ...form, beschreibung: e.target.value })}
                placeholder="z.B. Neukunden-Rabatt" />
            </div>
            <div className="form-group">
              <label>Gültig von</label>
              <input type="date" value={form.gueltigVon} min={new Date().toISOString().slice(0,10)}
                onChange={e => setForm({ ...form, gueltigVon: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Gültig bis</label>
              <input type="date" value={form.gueltigBis} min={form.gueltigVon || new Date().toISOString().slice(0,10)}
                onChange={e => setForm({ ...form, gueltigBis: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Max. Nutzungen</label>
              <input type="number" min="1" value={form.maxNutzungen}
                onChange={e => setForm({ ...form, maxNutzungen: e.target.value })}
                placeholder="unbegrenzt" />
            </div>
          </div>
          <button className="btn" type="submit"
            style={{ background: "#0277bd", color: "white" }}>
            ➕ Rabattcode erstellen
          </button>
        </form>
      </div>

      {/* ── Übersicht ── */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr><th>Code</th><th>Rabatt</th><th>Mindest</th><th>Beschreibung</th><th>Nutzungen</th><th>Gültig</th><th>Status</th><th>Aktion</th></tr>
          </thead>
          <tbody>
            {rabattcodes.length === 0 && (
              <tr><td colSpan={8} style={{ textAlign: "center", color: "#aaa", padding: "2rem" }}>Noch keine Rabattcodes.</td></tr>
            )}
            {rabattcodes.map(r => {
              const abgelaufen    = r.gueltigBis && new Date(String(r.gueltigBis).slice(0,10)+"T00:00:00") < new Date();
              const nochNichtGueltig = r.gueltigVon && new Date(String(r.gueltigVon).slice(0,10)+"T00:00:00") > new Date();
              const ausgeschoepft = r.maxNutzungen && r.aktuelleNutzungen >= r.maxNutzungen;
              return (
                <tr key={r.rabattcodeId} style={{ opacity: (!r.istAktiv || abgelaufen || ausgeschoepft) ? 0.55 : 1 }}>
                  <td>
                    <code style={{ background: "#e1f5fe", padding: "0.2rem 0.6rem", borderRadius: "6px", fontWeight: 700, color: "#0277bd", letterSpacing: 1 }}>
                      {r.code}
                    </code>
                  </td>
                  <td><strong>{r.wert}{r.typRabatt === "Prozent" ? "%" : " €"}</strong></td>
                  <td style={{ fontSize: "0.9rem", color: "#888" }}>{r.mindestBestellwert > 0 ? `${r.mindestBestellwert.toFixed(2)} €` : "–"}</td>
                  <td style={{ color: "#666", fontSize: "0.9rem" }}>{r.beschreibung ?? "–"}</td>
                  <td style={{ fontSize: "0.9rem" }}>
                    {r.aktuelleNutzungen}{r.maxNutzungen ? ` / ${r.maxNutzungen}` : " / ∞"}
                  </td>
                  <td style={{ fontSize: "0.85rem" }}>
                    {r.gueltigVon ? new Date(String(r.gueltigVon).slice(0,10)+"T00:00:00").toLocaleDateString("de-DE") : "∞"} –
                    {r.gueltigBis ? <span style={{ color: abgelaufen ? "#c62828" : "inherit" }}> {new Date(String(r.gueltigBis).slice(0,10)+"T00:00:00").toLocaleDateString("de-DE")}</span> : " ∞"}
                  </td>
                  <td>
                    <span className="badge" style={{
                      background: r.istAktiv && !abgelaufen && !ausgeschoepft && !nochNichtGueltig ? "#e8f5e9" : "#ffebee",
                      color:      r.istAktiv && !abgelaufen && !ausgeschoepft && !nochNichtGueltig ? "#2e7d32" : "#c62828",
                    }}>
                      {!r.istAktiv ? "Deaktiviert" : abgelaufen ? "Abgelaufen" : ausgeschoepft ? "Ausgeschöpft" : nochNichtGueltig ? "Noch nicht gültig" : "✓ Aktiv"}
                    </span>
                  </td>
                  <td style={{ display: "flex", gap: "0.4rem" }}>
                    <button className={`btn ${r.istAktiv ? "btn-secondary" : "btn-success"}`}
                      style={{ padding: "0.3rem 0.7rem", fontSize: "0.8rem" }}
                      onClick={() => toggleAktiv(r.rabattcodeId, !r.istAktiv)}>
                      {r.istAktiv ? "Deaktivieren" : "Aktivieren"}
                    </button>
                    <button style={{ padding: "0.3rem 0.7rem", fontSize: "0.8rem", background: "none", border: "1px solid #ffcdd2", borderRadius: "6px", cursor: "pointer", color: "#c62828" }}
                      onClick={() => del(r.rabattcodeId)}>
                      🗑️
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function GutscheineTab({ gutscheine, setGutscheine }) {
  const leer = { code: "", beschreibung: "", rabatt: "", rabattTyp: "Prozent", maxNutzungen: "", gueltigBis: "" };
  const [form,    setForm]    = useState(leer);
  const [success, setSuccess] = useState(false);
  const [error,   setError]   = useState(null);

  const handleCreate = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await api.gutscheine.create({
        ...form,
        rabatt:       parseFloat(form.rabatt),
        maxNutzungen: form.maxNutzungen ? parseInt(form.maxNutzungen) : null,
        gueltigBis:   form.gueltigBis || null,
      });
      setSuccess(true);
      setForm(leer);
      api.gutscheine.getAll().then(setGutscheine);
    } catch { setError("Fehler – Code bereits vergeben?"); }
  };

  const toggleAktiv = async (id, val) => {
    await api.gutscheine.toggleAktiv(id, val);
    setGutscheine(prev => prev.map(g => g.gutscheinId === id ? { ...g, istAktiv: val } : g));
  };

  const del = async (id) => {
    if (!window.confirm("Gutschein wirklich löschen?")) return;
    await api.gutscheine.delete(id);
    setGutscheine(prev => prev.filter(g => g.gutscheinId !== id));
  };

  // Zufälligen Code generieren
  const genCode = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    const code = Array.from({ length: 8 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
    setForm(f => ({ ...f, code }));
  };

  return (
    <div style={{ marginTop: "1rem" }}>
      {/* ── Neuen Gutschein erstellen ── */}
      <div className="card" style={{ border: "1.5px solid #ce93d8", marginBottom: "1.5rem" }}>
        <h3 style={{ color: "#6a1b9a", marginBottom: "1rem" }}>🎟️ Neuen Gutschein erstellen</h3>
        {success && <div className="alert alert-success">✓ Gutschein erstellt!</div>}
        {error   && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleCreate}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>Code *</label>
              <div style={{ display: "flex", gap: "0.4rem" }}>
                <input value={form.code} required
                  onChange={e => setForm({ ...form, code: e.target.value.toUpperCase() })}
                  placeholder="z.B. SOMMER24" style={{ flex: 1 }} />
                <button type="button" onClick={genCode}
                  style={{ padding: "0 0.7rem", borderRadius: "8px", border: "1px solid #ccc", cursor: "pointer", background: "#f3e5f5", fontSize: "0.85rem" }}>
                  🎲
                </button>
              </div>
            </div>
            <div className="form-group">
              <label>Rabatt *</label>
              <div style={{ display: "flex", gap: "0.4rem" }}>
                <input type="number" min="0" step="0.01" value={form.rabatt} required
                  onChange={e => setForm({ ...form, rabatt: e.target.value })}
                  placeholder="10" style={{ flex: 1 }} />
                <select value={form.rabattTyp} onChange={e => setForm({ ...form, rabattTyp: e.target.value })}
                  style={{ width: 90 }}>
                  <option value="Prozent">%</option>
                  <option value="Betrag">€</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label>Gültig bis</label>
              <input type="date" value={form.gueltigBis} min={new Date().toISOString().slice(0,10)}
                onChange={e => setForm({ ...form, gueltigBis: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Beschreibung</label>
              <input value={form.beschreibung}
                onChange={e => setForm({ ...form, beschreibung: e.target.value })}
                placeholder="z.B. Sommeraktion" />
            </div>
            <div className="form-group">
              <label>Max. Nutzungen</label>
              <input type="number" min="1" value={form.maxNutzungen}
                onChange={e => setForm({ ...form, maxNutzungen: e.target.value })}
                placeholder="unbegrenzt" />
            </div>
          </div>
          <button className="btn" type="submit"
            style={{ background: "#6a1b9a", color: "white" }}>
            ➕ Gutschein erstellen
          </button>
        </form>
      </div>

      {/* ── Übersicht ── */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr><th>Code</th><th>Rabatt</th><th>Beschreibung</th><th>Nutzungen</th><th>Gültig bis</th><th>Status</th><th>Aktion</th></tr>
          </thead>
          <tbody>
            {gutscheine.length === 0 && (
              <tr><td colSpan={7} style={{ textAlign: "center", color: "#aaa", padding: "2rem" }}>Noch keine Gutscheine.</td></tr>
            )}
            {gutscheine.map(g => {
              const abgelaufen = g.gueltigBis && new Date(String(g.gueltigBis).slice(0,10)+"T00:00:00") < new Date();
              const ausgeschoepft = g.maxNutzungen && g.nutzungen >= g.maxNutzungen;
              return (
                <tr key={g.gutscheinId} style={{ opacity: (!g.istAktiv || abgelaufen || ausgeschoepft) ? 0.55 : 1 }}>
                  <td>
                    <code style={{ background: "#f3e5f5", padding: "0.2rem 0.6rem", borderRadius: "6px", fontWeight: 700, color: "#6a1b9a", letterSpacing: 1 }}>
                      {g.code}
                    </code>
                  </td>
                  <td>
                    <strong>{g.rabatt}{g.rabattTyp === "Prozent" ? "%" : " €"}</strong>
                  </td>
                  <td style={{ color: "#666", fontSize: "0.9rem" }}>{g.beschreibung ?? "–"}</td>
                  <td style={{ fontSize: "0.9rem" }}>
                    {g.nutzungen}{g.maxNutzungen ? ` / ${g.maxNutzungen}` : " / ∞"}
                  </td>
                  <td style={{ fontSize: "0.9rem", color: abgelaufen ? "#c62828" : "#555" }}>
                    {g.gueltigBis ? new Date(String(g.gueltigBis).slice(0,10)+"T00:00:00").toLocaleDateString("de-DE") : "∞"}
                    {abgelaufen && <span style={{ marginLeft: "0.4rem", color: "#c62828" }}>⚠️</span>}
                  </td>
                  <td>
                    <span className="badge" style={{
                      background: g.istAktiv && !abgelaufen && !ausgeschoepft ? "#e8f5e9" : "#ffebee",
                      color:      g.istAktiv && !abgelaufen && !ausgeschoepft ? "#2e7d32" : "#c62828",
                    }}>
                      {!g.istAktiv ? "Deaktiviert" : abgelaufen ? "Abgelaufen" : ausgeschoepft ? "Ausgeschöpft" : "✓ Aktiv"}
                    </span>
                  </td>
                  <td style={{ display: "flex", gap: "0.4rem" }}>
                    <button className={`btn ${g.istAktiv ? "btn-secondary" : "btn-success"}`}
                      style={{ padding: "0.3rem 0.7rem", fontSize: "0.8rem" }}
                      onClick={() => toggleAktiv(g.gutscheinId, !g.istAktiv)}>
                      {g.istAktiv ? "Deaktivieren" : "Aktivieren"}
                    </button>
                    <button style={{ padding: "0.3rem 0.7rem", fontSize: "0.8rem", background: "none", border: "1px solid #ffcdd2", borderRadius: "6px", cursor: "pointer", color: "#c62828" }}
                      onClick={() => del(g.gutscheinId)}>
                      🗑️
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const WOCHENTAGE = { 1: "Mo", 2: "Di", 3: "Mi", 4: "Do", 5: "Fr", 6: "Sa", 7: "So" };

const WOCHENTAGE_LISTE = [
  { n: 1, label: "Mo" }, { n: 2, label: "Di" }, { n: 3, label: "Mi" },
  { n: 4, label: "Do" }, { n: 5, label: "Fr" }, { n: 6, label: "Sa" }, { n: 7, label: "So" },
];
const FARBEN = ["#1b5e20","#1565c0","#6a1b9a","#e65100","#b71c1c","#00695c","#f57f17","#4e342e","#37474f"];

function TourFormular({ initial, onSave, onCancel }) {
  const [name,      setName]      = useState(initial?.name ?? "");
  const [wochentage,setWochentage]= useState(() => (initial?.wochentage ?? "").split(",").filter(Boolean).map(Number));
  const [farbe,     setFarbe]     = useState(initial?.farbe ?? "#1b5e20");
  const [gruppeId,  setGruppeId]  = useState(initial?.gruppeId ?? "");

  const toggleTag = (n) => setWochentage(prev => prev.includes(n) ? prev.filter(x => x !== n) : [...prev, n].sort());

  return (
    <div style={{ background: "#f9fbe7", border: "1.5px solid #aed581", borderRadius: 10, padding: "1rem 1.25rem", marginBottom: "1rem" }}>
      <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", alignItems: "center", marginBottom: "0.75rem" }}>
        <input value={name} onChange={e => setName(e.target.value)} placeholder="Tour-Name z.B. Tour A"
          style={{ flex: 1, minWidth: 160, padding: "0.4rem 0.6rem", borderRadius: 6, border: "1px solid #ccc", fontSize: "0.95rem" }} />
        <input type="number" min="1" value={gruppeId} onChange={e => setGruppeId(e.target.value)}
          placeholder="Gruppen-ID"
          title="Gleiche Zahl = gleiche Gruppe (z.B. Braunschweig Mi + So beide Gruppe 1)"
          style={{ width: 110, padding: "0.4rem 0.6rem", borderRadius: 6, border: "1px solid #ccc", fontSize: "0.9rem" }} />
        <div style={{ display: "flex", gap: "0.3rem", flexWrap: "wrap" }}>
          {WOCHENTAGE_LISTE.map(({ n, label }) => (
            <button key={n} onClick={() => toggleTag(n)} style={{
              padding: "0.3rem 0.55rem", borderRadius: 6, border: "1.5px solid",
              borderColor: wochentage.includes(n) ? farbe : "#ccc",
              background: wochentage.includes(n) ? farbe : "white",
              color: wochentage.includes(n) ? "white" : "#555",
              fontWeight: 600, fontSize: "0.82rem", cursor: "pointer",
            }}>{label}</button>
          ))}
        </div>
        <div style={{ display: "flex", gap: "0.3rem" }}>
          {FARBEN.map(f => (
            <div key={f} onClick={() => setFarbe(f)} style={{
              width: 22, height: 22, borderRadius: "50%", background: f, cursor: "pointer",
              border: farbe === f ? "3px solid #333" : "2px solid transparent",
            }} />
          ))}
        </div>
      </div>
      <div style={{ display: "flex", gap: "0.5rem" }}>
        <button className="btn btn-primary" style={{ fontSize: "0.88rem" }}
          disabled={!name.trim() || wochentage.length === 0}
          onClick={() => onSave({ name: name.trim(), wochentage: wochentage.join(","), farbe, gruppeId: gruppeId ? parseInt(gruppeId) : null })}>
          {initial ? "✓ Speichern" : "➕ Tour erstellen"}
        </button>
        <button className="btn btn-secondary" style={{ fontSize: "0.88rem" }} onClick={onCancel}>Abbrechen</button>
      </div>
    </div>
  );
}

function TourenTab({ touren, setTouren }) {
  const [aufgeklappt,   setAufgeklappt]   = useState({});
  const [plzListen,     setPlzListen]     = useState({});
  const [neuPLZ,        setNeuPLZ]        = useState({});
  const [ohneTour,      setOhneTour]      = useState([]);
  const [zuweisung,     setZuweisung]     = useState({});
  const [saved,         setSaved]         = useState({});
  const [showCreate,    setShowCreate]    = useState(false);
  const [editTourId,    setEditTourId]    = useState(null);
  useEffect(() => {
    api.touren.getOhneTour().then(setOhneTour).catch(() => {});
  }, []);

  const reload = () => api.touren.getAll().then(setTouren);

  const createTour = async (data) => {
    await api.touren.create(data);
    await reload();
    setShowCreate(false);
  };

  const updateTour = async (id, data) => {
    await api.touren.update(id, data);
    await reload();
    setEditTourId(null);
  };

  const deleteTour = async (id) => {
    if (!window.confirm("Tour wirklich löschen? Alle PLZ-Bereiche dieser Tour werden ebenfalls gelöscht.")) return;
    await api.touren.delete(id);
    await reload();
  };

  const toggleAufklappen = async (tourId) => {
    const istOffen = aufgeklappt[tourId];
    setAufgeklappt(prev => ({ ...prev, [tourId]: !istOffen }));
    if (!istOffen && !plzListen[tourId]) {
      const plz = await api.touren.getPLZ(tourId);
      setPlzListen(prev => ({ ...prev, [tourId]: plz }));
    }
  };

  const addPLZ = async (tourId) => {
    const dto = neuPLZ[tourId] ?? {};
    if (!dto.plzPraefix?.trim()) return;
    await api.touren.addPLZ(tourId, { PLZPraefix: dto.plzPraefix, Beschreibung: dto.beschreibung });
    const plz = await api.touren.getPLZ(tourId);
    setPlzListen(prev => ({ ...prev, [tourId]: plz }));
    setNeuPLZ(prev => ({ ...prev, [tourId]: { plzPraefix: "", beschreibung: "" } }));
    api.touren.getAll().then(setTouren);
  };

  const deletePLZ = async (tourId, plzId) => {
    await api.touren.deletePLZ(plzId);
    setPlzListen(prev => ({ ...prev, [tourId]: prev[tourId].filter(p => p.tourPlzId !== plzId) }));
    api.touren.getAll().then(setTouren);
  };

  const saveZuweisung = async (bestellungId) => {
    const tourId = zuweisung[bestellungId];
    await api.touren.setManuelTour(bestellungId, tourId ? parseInt(tourId) : null);
    setSaved(prev => ({ ...prev, [bestellungId]: true }));
    // Aus der Liste entfernen wenn zugewiesen
    if (tourId) setOhneTour(prev => prev.filter(b => b.bestellungId !== bestellungId));
  };

  return (
    <div style={{ marginTop: "1rem" }}>

      {/* ── Ohne Tour ── */}
      {ohneTour.length > 0 && (
        <div className="card" style={{ border: "2px solid #ff9800", marginBottom: "1.5rem", background: "#fffde7" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1rem" }}>
            <span style={{ fontSize: "1.4rem" }}>⚠️</span>
            <div>
              <strong style={{ color: "#e65100", fontSize: "1.05rem" }}>Kunden ohne Tour ({ohneTour.length})</strong>
              <p style={{ color: "#888", fontSize: "0.85rem", margin: 0 }}>Diese Bestellungen passen in keine Tour-PLZ. Bitte manuell zuweisen.</p>
            </div>
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9rem" }}>
            <thead>
              <tr style={{ background: "#fff3e0" }}>
                <th style={{ padding: "0.5rem 0.75rem", textAlign: "left" }}>Kunde</th>
                <th style={{ padding: "0.5rem 0.75rem", textAlign: "left" }}>PLZ / Ort</th>
                <th style={{ padding: "0.5rem 0.75rem", textAlign: "left" }}>Produkt</th>
                <th style={{ padding: "0.5rem 0.75rem", textAlign: "left" }}>Intervall</th>
                <th style={{ padding: "0.5rem 0.75rem", textAlign: "left" }}>Tour zuweisen</th>
              </tr>
            </thead>
            <tbody>
              {ohneTour.map(b => (
                <tr key={b.bestellungId} style={{ borderTop: "1px solid #ffe0b2" }}>
                  <td style={{ padding: "0.6rem 0.75rem" }}>
                    <strong>{b.vorname} {b.nachname}</strong>
                    <br /><small style={{ color: "#888" }}>{b.email}</small>
                    {b.andereTourHinweis && (
                      <div style={{ marginTop: "0.25rem", fontSize: "0.78rem", color: "#e65100" }}>
                        ⚠ Andere Bestellung in: {b.andereTourHinweis}
                      </div>
                    )}
                  </td>
                  <td style={{ padding: "0.6rem 0.75rem" }}>
                    <span style={{ background: "#ffebee", color: "#c62828", padding: "0.15rem 0.5rem", borderRadius: "6px", fontSize: "0.85rem" }}>
                      {b.plz ?? "–"}
                    </span>
                    <br /><small style={{ color: "#888" }}>{b.ort ?? "–"}</small>
                  </td>
                  <td style={{ padding: "0.6rem 0.75rem" }}>{b.produktName ?? "–"}</td>
                  <td style={{ padding: "0.6rem 0.75rem" }}>
                    <span className="badge" style={{ background: "#e8f5e9", color: "#2e7d32" }}>{b.intervall ?? "–"}</span>
                  </td>
                  <td style={{ padding: "0.6rem 0.75rem" }}>
                    {saved[b.bestellungId] ? (
                      <span style={{ color: "#2e7d32", fontWeight: 600 }}>✓ Zugewiesen</span>
                    ) : (
                      <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                        <select
                          value={zuweisung[b.bestellungId] ?? ""}
                          onChange={e => setZuweisung(prev => ({ ...prev, [b.bestellungId]: e.target.value }))}
                          style={{ padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1px solid #ffcc80", fontSize: "0.85rem" }}>
                          <option value="">– Tour wählen –</option>
                          {touren.filter(t => t.istAktiv).map(t => (
                            <option key={t.tourId} value={t.tourId}>{t.name}</option>
                          ))}
                        </select>
                        <button
                          onClick={() => saveZuweisung(b.bestellungId)}
                          disabled={!zuweisung[b.bestellungId]}
                          className="btn btn-success"
                          style={{ padding: "0.3rem 0.75rem", fontSize: "0.85rem" }}>
                          ✓ Speichern
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p style={{ color: "#666", marginBottom: "1.5rem" }}>
        Hier legst du fest welche PLZ-Bereiche zu welcher Tour gehören. Kunden werden automatisch der passenden Tour zugeordnet.
      </p>

      {showCreate && (
        <TourFormular onSave={createTour} onCancel={() => setShowCreate(false)} />
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {touren.map(tour => {
          const tage = tour.wochentage.split(",").map(Number).map(n => WOCHENTAGE[n]).join(", ");
          const offen = aufgeklappt[tour.tourId];
          return (
            <div key={tour.tourId} className="card" style={{ border: `2px solid ${tour.farbe}33`, padding: 0, overflow: "hidden" }}>
              {editTourId === tour.tourId ? (
                <div style={{ padding: "0.75rem 1.25rem" }}>
                  <TourFormular initial={tour} onSave={data => updateTour(tour.tourId, data)} onCancel={() => setEditTourId(null)} />
                </div>
              ) : (
              /* Header */
              <div style={{ display: "flex", alignItems: "center", gap: "1rem", padding: "0.9rem 1.25rem", background: `${tour.farbe}11` }}>
                <div onClick={() => toggleAufklappen(tour.tourId)} style={{ display: "flex", alignItems: "center", gap: "1rem", flex: 1, cursor: "pointer" }}>
                  <div style={{ width: 14, height: 14, borderRadius: "50%", background: tour.farbe, flexShrink: 0 }} />
                  <strong style={{ color: tour.farbe, fontSize: "1.05rem" }}>{tour.name}</strong>
                  <span style={{ color: "#888", fontSize: "0.85rem" }}>📅 {tage}</span>
                  <span style={{ color: "#888", fontSize: "0.85rem" }}>📮 {tour.anzahlPLZ} PLZ-Bereiche</span>
                  {tour.gruppeId && <span style={{ background: "#ede7f6", color: "#6a1b9a", borderRadius: 6, padding: "0.1rem 0.5rem", fontSize: "0.78rem", fontWeight: 600 }}>Gruppe {tour.gruppeId}</span>}
                  <span style={{ color: "#888" }}>{offen ? "▲" : "▼"}</span>
                </div>
                <button onClick={() => setEditTourId(tour.tourId)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "1rem" }} title="Bearbeiten">✏️</button>
                <button onClick={() => deleteTour(tour.tourId)}   style={{ background: "none", border: "none", cursor: "pointer", fontSize: "1rem" }} title="Löschen">🗑️</button>
              </div>
              )}

              {/* PLZ-Liste */}
              {offen && (
                <div style={{ padding: "1rem 1.25rem" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "1rem" }}>
                    <thead>
                      <tr style={{ borderBottom: "1px solid #eee" }}>
                        <th style={{ textAlign: "left", padding: "0.4rem 0.5rem", fontSize: "0.85rem", color: "#888" }}>PLZ-Präfix</th>
                        <th style={{ textAlign: "left", padding: "0.4rem 0.5rem", fontSize: "0.85rem", color: "#888" }}>Beschreibung</th>
                        <th style={{ width: 60 }} />
                      </tr>
                    </thead>
                    <tbody>
                      {(plzListen[tour.tourId] ?? []).map(p => (
                        <tr key={p.tourPlzId} style={{ borderBottom: "1px solid #f5f5f5" }}>
                          <td style={{ padding: "0.4rem 0.5rem", fontFamily: "monospace", fontWeight: 600 }}>{p.plzPraefix}xxx</td>
                          <td style={{ padding: "0.4rem 0.5rem", color: "#666", fontSize: "0.9rem" }}>{p.beschreibung ?? "–"}</td>
                          <td style={{ padding: "0.4rem 0.5rem" }}>
                            <button onClick={() => deletePLZ(tour.tourId, p.tourPlzId)}
                              style={{ background: "none", border: "none", cursor: "pointer", color: "#e57373", fontSize: "1.1rem" }}>🗑️</button>
                          </td>
                        </tr>
                      ))}
                      {(plzListen[tour.tourId] ?? []).length === 0 && (
                        <tr><td colSpan={3} style={{ color: "#aaa", padding: "0.75rem 0.5rem", fontSize: "0.85rem" }}>Noch keine PLZ-Bereiche</td></tr>
                      )}
                    </tbody>
                  </table>

                  {/* Neue PLZ hinzufügen */}
                  <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", flexWrap: "wrap" }}>
                    <input type="text" placeholder="PLZ-Präfix z.B. 383"
                      value={neuPLZ[tour.tourId]?.plzPraefix ?? ""}
                      onChange={e => setNeuPLZ(prev => ({ ...prev, [tour.tourId]: { ...prev[tour.tourId], plzPraefix: e.target.value } }))}
                      style={{ width: 120, padding: "0.35rem 0.6rem", borderRadius: "6px", border: "1px solid #ccc", fontFamily: "monospace" }} />
                    <input type="text" placeholder="Beschreibung (optional)"
                      value={neuPLZ[tour.tourId]?.beschreibung ?? ""}
                      onChange={e => setNeuPLZ(prev => ({ ...prev, [tour.tourId]: { ...prev[tour.tourId], beschreibung: e.target.value } }))}
                      style={{ flex: 1, minWidth: 180, padding: "0.35rem 0.6rem", borderRadius: "6px", border: "1px solid #ccc" }} />
                    <button className="btn btn-success" style={{ padding: "0.35rem 0.9rem", fontSize: "0.85rem" }}
                      onClick={() => addPLZ(tour.tourId)}>+ Hinzufügen</button>
                  </div>
                  <p style={{ color: "#aaa", fontSize: "0.78rem", marginTop: "0.4rem" }}>
                    Präfix "383" matcht alle PLZ die mit 383 beginnen (38300–38399)
                  </p>
                </div>
              )}
            </div>
          );
        })}

        {!showCreate && (
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginTop: "0.5rem" }}>
            <button className="btn btn-secondary" style={{ alignSelf: "flex-start" }}
              onClick={() => { setShowCreate(true); setEditTourId(null); }}>
              ➕ Neue Tour erstellen
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function InventarRow({ produkt, inventar, flaschenTypen, onSave }) {
  const [typId, setTypId] = useState(inventar?.flaschenTypId ?? "");
  const [saved, setSaved] = useState(false);

  return (
    <tr>
      <td><strong>{produkt.name}</strong></td>
      <td style={{ color: "#888" }}>{produkt.einheit}</td>
      <td>
        <select value={typId} onChange={e => { setTypId(e.target.value === "" ? "" : parseInt(e.target.value)); setSaved(false); }}
          style={{ padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1px solid #ccc", fontSize: "0.9rem", minWidth: 160 }}>
          <option value="">– kein Pfand –</option>
          {flaschenTypen.map(t => (
            <option key={t.flaschenTypId} value={t.flaschenTypId}>{t.name} ({t.volumen}L)</option>
          ))}
        </select>
      </td>
      <td style={{ color: "#888", fontSize: "0.85rem" }}>{inventar?.aktualisiertAm ?? "–"}</td>
      <td>
        <button className="btn btn-success" style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem" }}
          onClick={async () => {
            await onSave(produkt.produktId, typId === "" ? null : parseInt(typId));
            setSaved(true);
            setTimeout(() => setSaved(false), 2000);
          }}>
          {saved ? "✓ Gespeichert" : "Speichern"}
        </button>
      </td>
    </tr>
  );
}

function FlaschenTab({ flaschen, setFlaschen, flaschenTypen, setFlaschenTypen }) {
  const [editId,    setEditId]    = useState(null);
  const [editWert,  setEditWert]  = useState(0);
  const [rueckgabe, setRueckgabe] = useState({});

  const saveAnzahl = async (userId) => {
    await api.flaschen.setAnzahl(userId, editWert);
    setFlaschen(prev => prev.map(f => f.userId === userId ? { ...f, anzahl: editWert } : f));
    setEditId(null);
  };

  const add = async (userId, delta) => {
    await api.flaschen.addAnzahl(userId, delta);
    setFlaschen(prev => prev.map(f =>
      f.userId === userId ? { ...f, anzahl: Math.max(0, f.anzahl + delta) } : f
    ));
  };

  const rueckgabeBestaetigen = async (userId, aktuelleAnzahl) => {
    const anzahlZurueck = rueckgabe[userId] ?? aktuelleAnzahl;
    const neu = Math.max(0, aktuelleAnzahl - anzahlZurueck);
    await api.flaschen.setAnzahl(userId, neu);
    setFlaschen(prev => prev.map(f => f.userId === userId ? { ...f, anzahl: neu } : f));
    setRueckgabe(prev => { const r = { ...prev }; delete r[userId]; return r; });
    // KPI-Karten aktualisieren
    api.inventar.getFlaschenTypen().then(setFlaschenTypen);
  };

  const mitFlaschen  = flaschen.filter(f => f.anzahl > 0);
  const ohneFlaschen = flaschen.filter(f => f.anzahl === 0);
  const gesamtDraussen = flaschen.reduce((s, f) => s + f.anzahl, 0);
  const kpiColors = ["#1565c0", "#2e7d32", "#e65100"];

  return (
    <div style={{ marginTop: "1rem" }}>

      {/* ── KPIs pro Flaschentyp ── */}
      <h3 style={{ color: "#2e7d32", marginBottom: "1rem" }}>🍼 Flaschen nach Typ</h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "1rem", marginBottom: "1rem" }}>
        {flaschenTypen.map((typ, idx) => {
          const color = kpiColors[idx % kpiColors.length];
          const pct   = typ.gesamtAnzahl > 0 ? Math.round((typ.beimKunden / typ.gesamtAnzahl) * 100) : 0;
          return (
            <div key={typ.flaschenTypId} className="card" style={{ border: `1.5px solid ${color}44`, padding: "1rem 1.25rem" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" }}>
                <strong style={{ color, fontSize: "1rem" }}>🍼 {typ.name}</strong>
                <span style={{ fontSize: "0.78rem", color: "#888" }}>{typ.volumen}L</span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.5rem", textAlign: "center" }}>
                <div>
                  <div style={{ fontSize: "1.7rem", fontWeight: 700, color, lineHeight: 1.1 }}>{typ.gesamtAnzahl}</div>
                  <div style={{ fontSize: "0.72rem", color: "#888" }}>Gesamt</div>
                </div>
                <div>
                  <div style={{ fontSize: "1.7rem", fontWeight: 700, color: "#e65100", lineHeight: 1.1 }}>{typ.beimKunden}</div>
                  <div style={{ fontSize: "0.72rem", color: "#888" }}>Bei Kunden</div>
                </div>
                <div>
                  <div style={{ fontSize: "1.7rem", fontWeight: 700, color: "#2e7d32", lineHeight: 1.1 }}>{typ.imLager}</div>
                  <div style={{ fontSize: "0.72rem", color: "#888" }}>Im Lager</div>
                </div>
              </div>
              {/* Fortschrittsbalken */}
              <div style={{ marginTop: "0.75rem" }}>
                <div style={{ height: 6, background: "#f5f5f5", borderRadius: 4, overflow: "hidden" }}>
                  <div style={{ height: "100%", width: `${pct}%`, background: pct > 80 ? "#c62828" : pct > 50 ? "#e65100" : color, borderRadius: 4, transition: "width 0.3s" }} />
                </div>
                <div style={{ fontSize: "0.72rem", color: "#888", marginTop: "0.2rem", textAlign: "right" }}>{pct}% draußen</div>
              </div>
              {/* Gesamt-Anzahl direkt editieren */}
              <FlaschenTypAnzahlEdit typ={typ} onSave={async (id, anz) => {
                await api.inventar.setGesamtAnzahl(id, anz);
                api.inventar.getFlaschenTypen().then(setFlaschenTypen);
              }} />
            </div>
          );
        })}
      </div>

      {/* ── Gesamt-KPIs ── */}
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "2rem" }}>
        {[
          { label: "Flaschen gesamt", value: flaschenTypen.reduce((s, t) => s + t.gesamtAnzahl, 0), bg: "#e8f5e9", border: "#a5d6a7", color: "#2e7d32" },
          { label: "Bei Kunden",      value: gesamtDraussen,                                         bg: "#fff3e0", border: "#ffcc80", color: "#e65100" },
          { label: "Im Lager",        value: flaschenTypen.reduce((s, t) => s + t.imLager, 0),       bg: "#e3f2fd", border: "#90caf9", color: "#1565c0" },
          { label: "Kunden m. Fl.",   value: mitFlaschen.length,                                      bg: "#fce4ec", border: "#f48fb1", color: "#c62828" },
        ].map(k => (
          <div key={k.label} className="card" style={{ background: k.bg, border: `1.5px solid ${k.border}`, padding: "0.75rem 1.5rem", textAlign: "center", flex: 1, minWidth: 120 }}>
            <div style={{ fontSize: "1.8rem", fontWeight: 700, color: k.color }}>{k.value}</div>
            <div style={{ color: "#555", fontSize: "0.85rem" }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* ── Kundenliste ── */}
      <h3 style={{ color: "#2e7d32", marginBottom: "1rem" }}>👥 Flaschen pro Kunde</h3>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr><th>Kunde</th><th>Email</th><th>Flaschen beim Kunden</th><th>Rückgabe buchen</th><th>Zuletzt aktualisiert</th><th>Manuell setzen</th></tr>
          </thead>
          <tbody>
            {flaschen.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: "center", color: "#aaa", padding: "2rem" }}>
                Noch keine Einträge.
              </td></tr>
            )}
            {[...mitFlaschen, ...ohneFlaschen].map(f => (
              <tr key={f.flascheId ?? f.userId} style={{ background: f.anzahl > 0 ? "#fffde7" : "white" }}>
                <td><strong>{f.vorname} {f.nachname}</strong></td>
                <td style={{ color: "#888", fontSize: "0.9rem" }}>{f.email}</td>
                <td>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <span style={{ fontWeight: 700, fontSize: "1.1rem", color: f.anzahl > 0 ? "#e65100" : "#aaa" }}>🍼 {f.anzahl}</span>
                    <button onClick={() => add(f.userId, -1)} disabled={f.anzahl === 0}
                      style={{ background: "none", border: "1px solid #ccc", borderRadius: "4px", width: 24, height: 24, cursor: "pointer" }}>−</button>
                    <button onClick={() => add(f.userId, 1)}
                      style={{ background: "none", border: "1px solid #ccc", borderRadius: "4px", width: 24, height: 24, cursor: "pointer" }}>+</button>
                  </div>
                </td>
                <td>
                  {f.anzahl > 0 ? (
                    <div style={{ display: "flex", gap: "0.4rem", alignItems: "center" }}>
                      <input type="number" min="1" max={f.anzahl}
                        value={rueckgabe[f.userId] ?? f.anzahl}
                        onChange={e => setRueckgabe(prev => ({ ...prev, [f.userId]: parseInt(e.target.value) || 0 }))}
                        style={{ width: 55, padding: "0.25rem 0.4rem", borderRadius: "6px", border: "1px solid #ccc", fontSize: "0.85rem" }} />
                      <button style={{ padding: "0.3rem 0.6rem", fontSize: "0.82rem", background: "#e8f5e9", color: "#2e7d32", border: "1px solid #a5d6a7", borderRadius: "6px", cursor: "pointer", whiteSpace: "nowrap" }}
                        onClick={() => rueckgabeBestaetigen(f.userId, f.anzahl)}>✓ Zurückgegeben</button>
                    </div>
                  ) : <span style={{ color: "#aaa", fontSize: "0.85rem" }}>–</span>}
                </td>
                <td style={{ color: "#888", fontSize: "0.85rem" }}>{f.aktualisiertAm}</td>
                <td>
                  {editId === f.userId ? (
                    <div style={{ display: "flex", gap: "0.4rem", alignItems: "center" }}>
                      <input type="number" min="0" value={editWert}
                        onChange={e => setEditWert(parseInt(e.target.value) || 0)}
                        style={{ width: 60, padding: "0.3rem", borderRadius: "6px", border: "1px solid #ccc" }} />
                      <button className="btn btn-success" style={{ padding: "0.2rem 0.6rem", fontSize: "0.8rem" }}
                        onClick={() => saveAnzahl(f.userId)}>✓</button>
                      <button className="btn btn-secondary" style={{ padding: "0.2rem 0.6rem", fontSize: "0.8rem" }}
                        onClick={() => setEditId(null)}>✗</button>
                    </div>
                  ) : (
                    <button className="btn btn-secondary" style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem" }}
                      onClick={() => { setEditId(f.userId); setEditWert(f.anzahl); }}>✏️ Setzen</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function FlaschenTypAnzahlEdit({ typ, onSave }) {
  const [edit, setEdit] = useState(false);
  const [wert, setWert] = useState(typ.gesamtAnzahl);
  return edit ? (
    <div style={{ display: "flex", gap: "0.4rem", alignItems: "center", marginTop: "0.75rem" }}>
      <input type="number" min="0" value={wert} onChange={e => setWert(parseInt(e.target.value) || 0)}
        style={{ flex: 1, padding: "0.25rem 0.4rem", borderRadius: "6px", border: "1px solid #ccc", fontSize: "0.85rem" }} />
      <button className="btn btn-success" style={{ padding: "0.2rem 0.5rem", fontSize: "0.8rem" }}
        onClick={() => { onSave(typ.flaschenTypId, wert); setEdit(false); }}>✓</button>
      <button className="btn btn-secondary" style={{ padding: "0.2rem 0.5rem", fontSize: "0.8rem" }}
        onClick={() => { setWert(typ.gesamtAnzahl); setEdit(false); }}>✗</button>
    </div>
  ) : (
    <button onClick={() => setEdit(true)}
      style={{ marginTop: "0.6rem", width: "100%", padding: "0.25rem", fontSize: "0.78rem", background: "none", border: "1px dashed #ccc", borderRadius: "6px", cursor: "pointer", color: "#888" }}>
      ✏️ Gesamt-Anzahl anpassen
    </button>
  );
}
function ProduktRow({ p, onUpdate }) {
  const [editPreis,   setEditPreis]  = useState(false);
  const [preis,       setPreis]      = useState(p.preis);
  const [editMenge,   setEditMenge]  = useState(false);
  const [minMenge,    setMinMenge]   = useState(p.mindestMenge ?? 1);
  const [editAbhol,   setEditAbhol]  = useState(false);
  const [abholPreis,  setAbholPreis] = useState(p.abholPreis ?? "");
  const [bildUrl,     setBildUrl]    = useState(p.bildUrl ?? null);
  const [bildLoading, setBildLoading]= useState(false);
  const bildRef = React.useRef();

  const uploadBild = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setBildLoading(true);
    try {
      const res = await api.produkte.uploadBild(p.produktId, file);
      setBildUrl(res.bildUrl);
      onUpdate(p.produktId, "bildUrl", res.bildUrl);
    } catch {} finally { setBildLoading(false); }
  };

  const removeBild = async () => {
    await api.produkte.deleteBild(p.produktId);
    setBildUrl(null);
    onUpdate(p.produktId, "bildUrl", null);
  };

  const savePreis = async () => {
    await api.produkte.updatePreis(p.produktId, parseFloat(preis));
    onUpdate(p.produktId, "preis", parseFloat(preis));
    setEditPreis(false);
  };

  const saveMenge = async () => {
    await api.produkte.updateMindestMenge(p.produktId, parseFloat(minMenge));
    onUpdate(p.produktId, "mindestMenge", parseFloat(minMenge));
    setEditMenge(false);
  };

  const saveAbhol = async () => {
    const val = abholPreis === "" ? null : parseFloat(abholPreis);
    await api.produkte.updateAbholPreis(p.produktId, val);
    onUpdate(p.produktId, "abholPreis", val);
    setEditAbhol(false);
  };

  const API_BASE = process.env.REACT_APP_API_URL?.replace("/api","") || "http://localhost:5115";

  return (
    <tr>
      <td>#{p.produktId}</td>
      <td>
        <strong>{p.name}</strong>
        {p.beschreibung && <><br /><small style={{ color: "#888" }}>{p.beschreibung}</small></>}
        <div style={{ marginTop: "0.5rem", display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
          {bildUrl && (
            <img src={`${API_BASE}${bildUrl}`} alt={p.name}
              style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 6, border: "1px solid #ddd" }} />
          )}
          <input ref={bildRef} type="file" accept=".jpg,.jpeg,.png,.webp" style={{ display: "none" }} onChange={uploadBild} />
          <button className="btn btn-secondary" style={{ padding: "0.2rem 0.6rem", fontSize: "0.78rem" }}
            disabled={bildLoading} onClick={() => bildRef.current.click()}>
            {bildLoading ? "⏳" : bildUrl ? "🖼️ Ändern" : "🖼️ Bild"}
          </button>
          {bildUrl && (
            <button style={{ background: "none", border: "none", color: "#e57373", cursor: "pointer", fontSize: "0.85rem" }}
              onClick={removeBild} title="Bild entfernen">✕</button>
          )}
        </div>
      </td>
      <td>
        {editPreis ? (
          <div style={{ display: "flex", gap: "0.4rem", alignItems: "center" }}>
            <input type="number" step="0.01" min="0" value={preis}
              onChange={e => setPreis(e.target.value)}
              style={{ width: 80, padding: "0.3rem", borderRadius: "6px", border: "1px solid #ccc", fontSize: "0.9rem" }} />
            <span style={{ fontSize: "0.9rem" }}>€</span>
            <button className="btn btn-success" style={{ padding: "0.2rem 0.6rem", fontSize: "0.8rem" }} onClick={savePreis}>✓</button>
            <button className="btn btn-secondary" style={{ padding: "0.2rem 0.6rem", fontSize: "0.8rem" }} onClick={() => { setEditPreis(false); setPreis(p.preis); }}>✗</button>
          </div>
        ) : (
          <span style={{ cursor: "pointer" }} onClick={() => setEditPreis(true)} title="Klicken zum Bearbeiten">
            {Number(p.preis).toFixed(2)} € ✏️
          </span>
        )}
      </td>
      <td>{p.einheit}</td>
      <td>
        <span className="badge" style={{
          background: p.istVerfuegbar ? "#e8f5e9" : "#ffebee",
          color:      p.istVerfuegbar ? "#2e7d32" : "#c62828"
        }}>
          {p.istVerfuegbar ? "✓ Verfügbar" : "✗ Nicht verfügbar"}
        </span>
      </td>
      <td>
        <button className={`btn ${p.istVerfuegbar ? "btn-secondary" : "btn-success"}`}
          style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem" }}
          onClick={() => {
            api.produkte.toggleVerfuegbar(p.produktId, !p.istVerfuegbar);
            onUpdate(p.produktId, "istVerfuegbar", !p.istVerfuegbar);
          }}>
          {p.istVerfuegbar ? "Deaktivieren" : "Aktivieren"}
        </button>
      </td>
    </tr>
  );
}


function BesichtigungRow({ b, onUpdate, onDelete }) {
  const [nachricht, setNachricht] = useState("");
  const [open, setOpen] = useState(false);

  return (
    <>
      <tr>
        <td>#{b.besichtigungId}</td>
        <td>
          <strong>{b.vorname} {b.nachname}</strong>
          <br /><small style={{ color: "#888" }}>{b.email}</small>
        </td>
        <td>{b.datum ? new Date(String(b.datum).slice(0,10) + "T00:00:00").toLocaleDateString("de-DE") : "–"}</td>
        <td>{b.uhrzeit}</td>
        <td>{b.personenanzahl}</td>
        <td style={{ maxWidth: 180, fontSize: "0.85rem", color: "#555" }}>{b.nachricht ?? "–"}</td>
        <td>
          <span className="badge" style={{
            background: b.status === "Bestätigt" ? "#e8f5e9" : b.status === "Abgelehnt" ? "#ffebee" : "#fff3e0",
            color:      b.status === "Bestätigt" ? "#2e7d32" : b.status === "Abgelehnt" ? "#c62828" : "#e65100"
          }}>{b.status}</span>
        </td>
        <td>
          <div style={{ display: "flex", gap: "0.4rem" }}>
            <button className="btn btn-secondary"
              style={{ padding: "0.3rem 0.8rem", fontSize: "0.8rem" }}
              onClick={() => setOpen(o => !o)}>
              ✏️ Antworten
            </button>
            <button
              style={{ padding: "0.3rem 0.6rem", fontSize: "0.8rem", background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "6px", cursor: "pointer" }}
              onClick={() => { if (window.confirm("Besichtigung löschen?")) onDelete(b.besichtigungId); }}>
              🗑️
            </button>
          </div>
        </td>
      </tr>
      {open && (
        <tr>
          <td colSpan={8} style={{ background: "#f9f9f9", padding: "0.75rem 1rem" }}>
            <div style={{ display: "flex", gap: "0.75rem", alignItems: "flex-end" }}>
              <textarea rows={2} value={nachricht} onChange={e => setNachricht(e.target.value)}
                placeholder="Nachricht an den Kunden (optional)..."
                style={{ flex: 1, padding: "0.5rem", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.9rem" }} />
              <button className="btn btn-success"
                style={{ padding: "0.5rem 1rem" }}
                onClick={() => { onUpdate(b.besichtigungId, "Bestätigt", nachricht); setOpen(false); }}>
                ✓ Bestätigen
              </button>
              <button className="btn"
                style={{ padding: "0.5rem 1rem", background: "#c62828", color: "white" }}
                onClick={() => { onUpdate(b.besichtigungId, "Abgelehnt", nachricht); setOpen(false); }}>
                ✗ Ablehnen
              </button>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

function NewsTab({ news, setNews }) {
  const leer = { titel: "", inhalt: "", bildBase64: null };
  const [form,      setForm]      = useState(leer);
  const [editId,    setEditId]    = useState(null);
  const [loading,   setLoading]   = useState(false);
  const [bildPreview, setBildPreview] = useState(null);

  const handleBild = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const base64 = ev.target.result; // inkl. data:image/...;base64,
      setForm(f => ({ ...f, bildBase64: base64 }));
      setBildPreview(base64);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editId) {
        await api.news.update(editId, form);
        setNews(prev => prev.map(n => n.newsId === editId ? { ...n, ...form } : n));
      } else {
        const res = await api.news.create(form);
        setNews(prev => [{ newsId: res.newsId, ...form, erstelltAm: new Date().toISOString().slice(0,10), istAktiv: true }, ...prev]);
      }
      setForm(leer); setEditId(null); setBildPreview(null);
    } finally { setLoading(false); }
  };

  const startEdit = (n) => {
    setEditId(n.newsId);
    setForm({ titel: n.titel, inhalt: n.inhalt, bildBase64: n.bildBase64 });
    setBildPreview(n.bildBase64);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={{ marginTop: "1rem" }}>
      {/* ── Formular ── */}
      <div className="card" style={{ marginBottom: "1.5rem", border: "1.5px solid #a5d6a7" }}>
        <h3 style={{ color: "#2e7d32", marginBottom: "1.25rem" }}>
          {editId ? "✏️ News bearbeiten" : "➕ Neue News erstellen"}
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Titel *</label>
            <input value={form.titel} onChange={e => setForm({ ...form, titel: e.target.value })}
              placeholder="z.B. Neue Sommerpreise ab Juli" required />
          </div>
          <div className="form-group">
            <label>Text *</label>
            <textarea rows={5} value={form.inhalt} onChange={e => setForm({ ...form, inhalt: e.target.value })}
              placeholder="Inhalt der News..."
              style={{ width: "100%", padding: "0.6rem", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.95rem", resize: "vertical" }}
              required />
          </div>
          <div className="form-group">
            <label>Bild (optional)</label>
            <input type="file" accept="image/*" onChange={handleBild}
              style={{ display: "block", marginBottom: "0.5rem" }} />
            {bildPreview && (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img src={bildPreview} alt="Vorschau"
                  style={{ maxHeight: 180, maxWidth: "100%", borderRadius: "8px", border: "1px solid #e0e0e0" }} />
                <button type="button"
                  onClick={() => { setForm(f => ({ ...f, bildBase64: null })); setBildPreview(null); }}
                  style={{ position: "absolute", top: 4, right: 4, background: "rgba(0,0,0,0.6)", color: "white", border: "none", borderRadius: "50%", width: 24, height: 24, cursor: "pointer", fontSize: "0.8rem" }}>
                  ✕
                </button>
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: "0.75rem" }}>
            <button className="btn btn-success" type="submit" disabled={loading}>
              {loading ? "⏳ Speichern..." : editId ? "✓ Aktualisieren" : "➕ Erstellen"}
            </button>
            {editId && (
              <button type="button" className="btn btn-secondary"
                onClick={() => { setForm(leer); setEditId(null); setBildPreview(null); }}>
                Abbrechen
              </button>
            )}
          </div>
        </form>
      </div>

      {/* ── News Liste ── */}
      {news.length === 0 && (
        <div className="card" style={{ textAlign: "center", color: "#aaa" }}>Noch keine News erstellt.</div>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {news.map(n => (
          <div key={n.newsId} className="card" style={{ border: `1.5px solid ${n.istAktiv ? "#a5d6a7" : "#e0e0e0"}`, opacity: n.istAktiv ? 1 : 0.6 }}>
            <div style={{ display: "flex", gap: "1rem" }}>
              {n.bildBase64 && (
                <img src={n.bildBase64} alt={n.titel}
                  style={{ width: 120, height: 80, objectFit: "cover", borderRadius: "8px", flexShrink: 0 }} />
              )}
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "1rem" }}>
                  <div>
                    <strong style={{ fontSize: "1.05rem", color: "#1b5e20" }}>{n.titel}</strong>
                    <br /><small style={{ color: "#888" }}>{n.erstelltAm ? new Date(n.erstelltAm + "T00:00:00").toLocaleDateString("de-DE") : ""}</small>
                  </div>
                  <span className="badge" style={{
                    background: n.istAktiv ? "#e8f5e9" : "#f5f5f5",
                    color: n.istAktiv ? "#2e7d32" : "#999", flexShrink: 0
                  }}>{n.istAktiv ? "✓ Aktiv" : "Inaktiv"}</span>
                </div>
                <p style={{ color: "#555", fontSize: "0.9rem", marginTop: "0.4rem", whiteSpace: "pre-wrap" }}>
                  {n.inhalt?.length > 150 ? n.inhalt.slice(0, 150) + "…" : n.inhalt}
                </p>
                <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.75rem", flexWrap: "wrap" }}>
                  <button className="btn btn-secondary" style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem" }}
                    onClick={() => startEdit(n)}>✏️ Bearbeiten</button>
                  <button style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem", borderRadius: "6px", border: "1px solid #ccc", cursor: "pointer", background: n.istAktiv ? "#fff3e0" : "#e8f5e9", color: n.istAktiv ? "#e65100" : "#2e7d32" }}
                    onClick={async () => {
                      await api.news.toggleAktiv(n.newsId, !n.istAktiv);
                      setNews(prev => prev.map(x => x.newsId === n.newsId ? { ...x, istAktiv: !n.istAktiv } : x));
                    }}>
                    {n.istAktiv ? "⏸️ Deaktivieren" : "▶️ Aktivieren"}
                  </button>
                  <button style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem", borderRadius: "6px", border: "1px solid #ffcdd2", cursor: "pointer", background: "#ffebee", color: "#c62828" }}
                    onClick={async () => {
                      if (!window.confirm("News löschen?")) return;
                      await api.news.delete(n.newsId);
                      setNews(prev => prev.filter(x => x.newsId !== n.newsId));
                    }}>🗑️ Löschen</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Kunde manuell anlegen ─────────────────────────────────
function KundeAnlegenModal({ onClose, onSuccess }) {
  const ROLLEN = ["Kunde", "Fahrer", "FahrerAdmin", "Molkerei", "MolkereiAdmin", "Admin"];
  const leer = { vorname: "", nachname: "", email: "", telefon: "", passwort: "", rolle: "Kunde" };
  const [form,    setForm]    = useState(leer);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);
  const [success, setSuccess] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!form.vorname || !form.nachname || !form.email || !form.passwort) {
      setError("Bitte alle Pflichtfelder ausfüllen."); return;
    }
    setLoading(true);
    try {
      const res = await api.auth.adminRegister(form);
      // Rolle setzen wenn nicht Standard-Kunde
      if (form.rolle !== "Kunde") {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/users/${res.userId}/rolle`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ rolle: form.rolle }),
        });
      }
      setSuccess(true);
      setTimeout(() => { onSuccess?.(); onClose(); }, 1200);
    } catch (err) {
      setError(err.message || "Fehler beim Anlegen.");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div style={{ background: "white", borderRadius: "14px", padding: "1.75rem", maxWidth: 480, width: "100%", boxShadow: "0 8px 40px rgba(0,0,0,0.2)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ color: "#1565c0", margin: 0 }}>👤 Neuen Kunden anlegen</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: "1.4rem", cursor: "pointer", color: "#aaa" }}>✕</button>
        </div>

        {success && <div className="alert alert-success">✓ Kunde wurde angelegt!</div>}
        {error   && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 1rem" }}>
            <div className="form-group">
              <label>Vorname *</label>
              <input value={form.vorname} onChange={e => set("vorname", e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Nachname *</label>
              <input value={form.nachname} onChange={e => set("nachname", e.target.value)} required />
            </div>
          </div>
          <div className="form-group">
            <label>E-Mail *</label>
            <input type="email" value={form.email} onChange={e => set("email", e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Telefon</label>
            <input value={form.telefon} onChange={e => set("telefon", e.target.value)} placeholder="optional" />
          </div>
          <div className="form-group">
            <label>Rolle</label>
            <select value={form.rolle} onChange={e => set("rolle", e.target.value)}>
              {ROLLEN.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Temporäres Passwort *</label>
            <input type="text" value={form.passwort} onChange={e => set("passwort", e.target.value)}
              placeholder="Kann später geändert werden" required />
          </div>
          <div style={{ display: "flex", gap: "0.75rem", marginTop: "0.5rem" }}>
            <button type="submit" className="btn" disabled={loading}
              style={{ background: "#1565c0", color: "white", flex: 1 }}>
              {loading ? "⏳ Wird angelegt..." : "✓ Kunden anlegen"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ── Benutzerverwaltung: Rollen zuweisen ──────────────────
function BenutzerverwaltungSection() {
  const [users,               setUsers]               = useState([]);
  const [loading,             setLoading]             = useState(true);
  const [saved,               setSaved]               = useState({});
  const [showAnlegen,         setShowAnlegen]         = useState(false);
  const [filter,              setFilter]              = useState("alle");
  const [suche,               setSuche]               = useState("");
  const [sepaOpen,            setSepaOpen]            = useState(null);
  const [sepaForm,            setSepaForm]            = useState({ sepaIban: "", sepaMandatRef: "", sepaMandatDatum: "" });
  const [sepaLoading,         setSepaLoading]         = useState(false);
  const [sepaMsg,             setSepaMsg]             = useState({});
  const [editOpen,            setEditOpen]            = useState(null);
  const [editForm,            setEditForm]            = useState({});
  const [editLoading,         setEditLoading]         = useState(false);
  const [deaktivierenConfirm, setDeaktivierenConfirm] = useState(null); // user-Objekt

  const ROLLEN = ["Kunde", "Firma", "Fahrer", "FahrerAdmin", "Molkerei", "MolkereiAdmin", "Admin"];
  const ROLLEN_LABELS = {
    Kunde:         "👤 Kunde",
    Firma:         "🏢 Firma",
    Fahrer:        "🚚 Fahrer",
    FahrerAdmin:   "🚚★ FahrerAdmin",
    Molkerei:      "🥛 Molkerei",
    MolkereiAdmin: "🥛★ MolkereiAdmin",
    Admin:         "🔑 Admin",
  };

  const loadUsers = () =>
    fetch(process.env.REACT_APP_API_URL + "/auth/users")
      .then(r => r.json())
      .then(setUsers)
      .catch(() => {});

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/auth/users")
      .then(r => r.json())
      .then(data => { setUsers(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const openEdit = (u) => {
    if (editOpen === u.userId) { setEditOpen(null); return; }
    setEditOpen(u.userId);
    setEditForm({ vorname: u.vorname, nachname: u.nachname, email: u.email,
                  telefon: u.telefon ?? "", rolle: u.rolle, kundennummer: u.kundennummer ?? "" });
  };

  const saveEdit = async (userId) => {
    setEditLoading(true);
    try {
      await api.kunden.updateUser(userId, {
        vorname:      editForm.vorname,
        nachname:     editForm.nachname,
        email:        editForm.email,
        telefon:      editForm.telefon || null,
        rolle:        editForm.rolle,
        kundennummer: editForm.kundennummer || null,
      });
      setEditOpen(null);
      loadUsers();
    } catch (e) { alert(e.message ?? "Fehler beim Speichern."); }
    finally { setEditLoading(false); }
  };

  const deaktivieren = async (u) => {
    await api.kunden.deaktivieren(u.userId);
    setDeaktivierenConfirm(null);
    loadUsers();
  };

  const reaktivieren = async (userId) => {
    await api.kunden.reaktivieren(userId);
    loadUsers();
  };

  const rolleAendern = async (userId, neueRolle) => {
    setUsers(prev => prev.map(u => u.userId === userId ? { ...u, rolle: neueRolle } : u));
    await fetch(`${process.env.REACT_APP_API_URL}/auth/users/${userId}/rolle`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ rolle: neueRolle }),
    });
    setSaved(prev => ({ ...prev, [userId]: true }));
    setTimeout(() => setSaved(prev => ({ ...prev, [userId]: false })), 2000);
  };

  const rollenFarbe = (rolle) => ({
    Kunde:         { bg: "#f5f5f5", color: "#555" },
    Firma:         { bg: "#fff8e1", color: "#f57f17" },
    Fahrer:        { bg: "#e3f2fd", color: "#1565c0" },
    FahrerAdmin:   { bg: "#1565c0", color: "white" },
    Molkerei:      { bg: "#e8f5e9", color: "#2e7d32" },
    MolkereiAdmin: { bg: "#2e7d32", color: "white" },
    Admin:         { bg: "#fce4ec", color: "#c62828" },
  }[rolle] ?? { bg: "#f5f5f5", color: "#555" });

  const openSepaForm = async (userId) => {
    if (sepaOpen === userId) { setSepaOpen(null); return; }
    setSepaOpen(userId);
    setSepaForm({ sepaIban: "", sepaMandatRef: "", sepaMandatDatum: "" });
    try {
      const data = await api.kunden.getSepa(userId);
      setSepaForm({
        sepaIban:        data?.sepaIban        ?? "",
        sepaMandatRef:   data?.sepaMandatRef   ?? "",
        sepaMandatDatum: data?.sepaMandatDatum ?? "",
      });
    } catch {}
  };

  const saveSepa = async (userId) => {
    setSepaLoading(true);
    try {
      await api.kunden.updateSepa(userId, {
        sepaIban:        sepaForm.sepaIban       || null,
        sepaMandatRef:   sepaForm.sepaMandatRef  || null,
        sepaMandatDatum: sepaForm.sepaMandatDatum || null,
      });
      setSepaMsg(prev => ({ ...prev, [userId]: "✓ Gespeichert" }));
      setTimeout(() => setSepaMsg(prev => ({ ...prev, [userId]: null })), 3000);
    } catch { setSepaMsg(prev => ({ ...prev, [userId]: "Fehler" })); }
    finally { setSepaLoading(false); }
  };

  return (
    <>
    {showAnlegen && (
      <KundeAnlegenModal
        onClose={() => setShowAnlegen(false)}
        onSuccess={() => {
          setShowAnlegen(false);
          fetch(process.env.REACT_APP_API_URL + "/auth/users").then(r => r.json()).then(setUsers).catch(() => {});
        }}
      />
    )}

    <div className="card" style={{ maxWidth: 700, marginTop: "1.5rem" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
        <h3 style={{ color: "#1565c0", margin: 0 }}>👥 Benutzerverwaltung & Rollen</h3>
        <button className="btn" onClick={() => setShowAnlegen(true)}
          style={{ background: "#1565c0", color: "white", padding: "0.4rem 1rem", fontSize: "0.88rem" }}>
          ➕ Neuen Kunden anlegen
        </button>
      </div>
      <p style={{ color: "#666", fontSize: "0.88rem", marginBottom: "1rem" }}>
        Weise Benutzern Rollen zu. <strong>FahrerAdmin</strong> und <strong>MolkereiAdmin</strong> können Dienstpläne erstellen und bearbeiten.
      </p>
      <input
        type="text"
        placeholder="🔍 Name oder E-Mail suchen..."
        value={suche}
        onChange={e => setSuche(e.target.value)}
        style={{ width: "100%", padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1.5px solid #ddd", fontSize: "0.9rem", marginBottom: "0.75rem", boxSizing: "border-box" }}
      />
      <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem", flexWrap: "wrap" }}>
        {[
          { key: "alle",         label: `Alle (${users.length})` },
          { key: "kunden",       label: `👤 Kunden (${users.filter(u => u.rolle === "Kunde").length})` },
          { key: "firmen",       label: `🏢 Firmen (${users.filter(u => u.rolle === "Firma").length})` },
          { key: "mitarbeiter",  label: `👷 Mitarbeiter (${users.filter(u => u.rolle !== "Kunde" && u.rolle !== "Firma").length})` },
        ].map(({ key, label }) => (
          <button key={key}
            className={`btn ${filter === key ? "btn-success" : "btn-secondary"}`}
            onClick={() => setFilter(key)}
            style={{ padding: "0.3rem 0.85rem", fontSize: "0.85rem" }}>
            {label}
          </button>
        ))}
      </div>
      {loading ? (
        <div style={{ color: "#aaa", textAlign: "center", padding: "1rem" }}>Lädt...</div>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9rem" }}>
          <thead>
            <tr style={{ background: "#f5f5f5" }}>
              <th style={{ padding: "0.5rem 0.75rem", textAlign: "left" }}>Name / Kontakt</th>
              <th style={{ padding: "0.5rem 0.75rem", textAlign: "left" }}>Lieferadresse</th>
              <th style={{ padding: "0.5rem 0.75rem", textAlign: "left" }}>Rolle</th>
              <th style={{ padding: "0.5rem 0.75rem", textAlign: "center" }}>Status</th>
              <th style={{ padding: "0.5rem 0.75rem", textAlign: "center" }}>SEPA</th>
              <th style={{ padding: "0.5rem 0.75rem", textAlign: "center" }}>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {deaktivierenConfirm && (
              <tr key="confirm-deaktivieren">
                <td colSpan={6} style={{ padding: 0 }}>
                  <div style={{ background: "#fff3e0", border: "1.5px solid #ffb74d", borderRadius: "8px", margin: "0.5rem", padding: "1rem", display: "flex", gap: "1rem", alignItems: "center", flexWrap: "wrap" }}>
                    <span style={{ flex: 1, fontSize: "0.9rem", color: "#e65100" }}>
                      Kunde <strong>{deaktivierenConfirm.vorname} {deaktivierenConfirm.nachname}</strong> wirklich deaktivieren?
                      Alle aktiven Bestellungen werden ebenfalls deaktiviert.
                    </span>
                    <button onClick={() => setDeaktivierenConfirm(null)}
                      style={{ padding: "0.35rem 0.9rem", fontSize: "0.85rem", background: "#f5f5f5", border: "1px solid #ccc", borderRadius: "7px", cursor: "pointer" }}>
                      Abbrechen
                    </button>
                    <button onClick={() => deaktivieren(deaktivierenConfirm)}
                      style={{ padding: "0.35rem 0.9rem", fontSize: "0.85rem", background: "#c62828", color: "white", border: "none", borderRadius: "7px", cursor: "pointer", fontWeight: 600 }}>
                      Bestätigen
                    </button>
                  </div>
                </td>
              </tr>
            )}
            {users.filter(u => {
              const rolleOk = filter === "kunden"      ? u.rolle === "Kunde" :
                              filter === "firmen"       ? u.rolle === "Firma" :
                              filter === "mitarbeiter"  ? u.rolle !== "Kunde" && u.rolle !== "Firma" : true;
              const q = suche.trim().toLowerCase();
              const sucheOk = !q || `${u.vorname} ${u.nachname} ${u.email} ${u.telefon ?? ""} ${u.strasse ?? ""} ${u.ort ?? ""}`.toLowerCase().includes(q);
              return rolleOk && sucheOk;
            }).flatMap((u, i) => {
              const style    = rollenFarbe(u.rolle);
              const inaktiv  = u.istAktiv === false;
              const zeileBg  = inaktiv ? "#f5f5f5" : (i % 2 === 0 ? "white" : "#fafafa");
              const rows = [
                <tr key={u.userId} style={{ borderTop: "1px solid #f0f0f0", background: zeileBg, opacity: inaktiv ? 0.6 : 1 }}>
                  <td style={{ padding: "0.5rem 0.75rem" }}>
                    <div style={{ fontWeight: 500, color: inaktiv ? "#aaa" : undefined }}>
                      {u.vorname} {u.nachname}
                      {inaktiv && <span style={{ marginLeft: "0.5rem", fontSize: "0.75rem", background: "#e0e0e0", color: "#888", padding: "0.1rem 0.4rem", borderRadius: "4px" }}>Deaktiviert</span>}
                    </div>
                    <div style={{ color: "#aaa", fontSize: "0.82rem" }}>{u.email}</div>
                    {u.telefon && <div style={{ color: "#777", fontSize: "0.8rem" }}>📞 {u.telefon}</div>}
                    {u.kundennummer && <div style={{ color: "#bbb", fontSize: "0.75rem" }}>#{u.kundennummer}</div>}
                  </td>
                  <td style={{ padding: "0.5rem 0.75rem", fontSize: "0.82rem", color: "#555" }}>
                    {u.strasse
                      ? <><div>{u.strasse}</div><div>{u.plz} {u.ort}</div></>
                      : <span style={{ color: "#ccc" }}>–</span>}
                  </td>
                  <td style={{ padding: "0.5rem 0.75rem" }}>
                    <select
                      value={u.rolle ?? "Kunde"}
                      onChange={e => rolleAendern(u.userId, e.target.value)}
                      disabled={inaktiv}
                      style={{
                        padding: "0.25rem 0.5rem", borderRadius: "6px", fontSize: "0.85rem",
                        border: `1.5px solid ${style.bg === "white" || style.bg === "#f5f5f5" ? "#ccc" : style.bg}`,
                        background: style.bg, color: style.color, fontWeight: 600, cursor: inaktiv ? "default" : "pointer",
                      }}>
                      {ROLLEN.map(r => (
                        <option key={r} value={r}>{ROLLEN_LABELS[r]}</option>
                      ))}
                    </select>
                  </td>
                  <td style={{ padding: "0.5rem 0.75rem", textAlign: "center" }}>
                    {saved[u.userId]
                      ? <span style={{ color: "#2e7d32", fontSize: "0.82rem" }}>✓ Gespeichert</span>
                      : <span style={{ ...style, padding: "0.15rem 0.6rem", borderRadius: "6px", fontSize: "0.8rem" }}>{ROLLEN_LABELS[u.rolle] ?? u.rolle}</span>
                    }
                  </td>
                  <td style={{ padding: "0.5rem 0.75rem", textAlign: "center" }}>
                    <button
                      onClick={() => openSepaForm(u.userId)}
                      style={{ padding: "0.2rem 0.6rem", fontSize: "0.78rem", background: sepaOpen === u.userId ? "#e3f2fd" : "#f5f5f5", color: "#1565c0", border: "1px solid #bcd", borderRadius: "6px", cursor: "pointer", fontWeight: 600 }}>
                      🏦 SEPA
                    </button>
                  </td>
                  <td style={{ padding: "0.5rem 0.75rem", textAlign: "center" }}>
                    <div style={{ display: "flex", gap: "0.3rem", justifyContent: "center", flexWrap: "wrap" }}>
                      <button onClick={() => openEdit(u)}
                        style={{ padding: "0.2rem 0.55rem", fontSize: "0.78rem", background: editOpen === u.userId ? "#fff8e1" : "#f5f5f5", color: "#555", border: "1px solid #ddd", borderRadius: "6px", cursor: "pointer" }}>
                        ✏️
                      </button>
                      {inaktiv ? (
                        <button onClick={() => reaktivieren(u.userId)}
                          style={{ padding: "0.2rem 0.55rem", fontSize: "0.78rem", background: "#e8f5e9", color: "#2e7d32", border: "1px solid #a5d6a7", borderRadius: "6px", cursor: "pointer", fontWeight: 600 }}>
                          ✅ Reaktivieren
                        </button>
                      ) : (
                        <button onClick={() => setDeaktivierenConfirm(u)}
                          style={{ padding: "0.2rem 0.55rem", fontSize: "0.78rem", background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "6px", cursor: "pointer", fontWeight: 600 }}>
                          🚫 Deaktivieren
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ];
              if (editOpen === u.userId) {
                rows.push(
                  <tr key={`edit-${u.userId}`} style={{ background: "#fffde7" }}>
                    <td colSpan={6} style={{ padding: "0.75rem 1rem" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr auto", gap: "0.5rem", alignItems: "end" }}>
                        <div>
                          <label style={{ fontSize: "0.8rem", color: "#555" }}>Vorname</label>
                          <input value={editForm.vorname} onChange={e => setEditForm(f => ({ ...f, vorname: e.target.value }))}
                            style={{ width: "100%", padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1.5px solid #ddd", fontSize: "0.85rem", boxSizing: "border-box" }} />
                        </div>
                        <div>
                          <label style={{ fontSize: "0.8rem", color: "#555" }}>Nachname</label>
                          <input value={editForm.nachname} onChange={e => setEditForm(f => ({ ...f, nachname: e.target.value }))}
                            style={{ width: "100%", padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1.5px solid #ddd", fontSize: "0.85rem", boxSizing: "border-box" }} />
                        </div>
                        <div>
                          <label style={{ fontSize: "0.8rem", color: "#555" }}>E-Mail</label>
                          <input type="email" value={editForm.email} onChange={e => setEditForm(f => ({ ...f, email: e.target.value }))}
                            style={{ width: "100%", padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1.5px solid #ddd", fontSize: "0.85rem", boxSizing: "border-box" }} />
                        </div>
                        <div>
                          <label style={{ fontSize: "0.8rem", color: "#555" }}>Telefon</label>
                          <input value={editForm.telefon} onChange={e => setEditForm(f => ({ ...f, telefon: e.target.value }))}
                            style={{ width: "100%", padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1.5px solid #ddd", fontSize: "0.85rem", boxSizing: "border-box" }} />
                        </div>
                        <div>
                          <label style={{ fontSize: "0.8rem", color: "#555" }}>Kundennummer</label>
                          <input value={editForm.kundennummer} onChange={e => setEditForm(f => ({ ...f, kundennummer: e.target.value }))}
                            style={{ width: "100%", padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1.5px solid #ddd", fontSize: "0.85rem", boxSizing: "border-box" }} />
                        </div>
                        <div style={{ display: "flex", gap: "0.4rem" }}>
                          <button className="btn btn-success" disabled={editLoading} onClick={() => saveEdit(u.userId)}
                            style={{ padding: "0.3rem 0.7rem", fontSize: "0.82rem", whiteSpace: "nowrap" }}>
                            {editLoading ? "..." : "💾 Speichern"}
                          </button>
                          <button className="btn btn-secondary" onClick={() => setEditOpen(null)}
                            style={{ padding: "0.3rem 0.6rem", fontSize: "0.82rem" }}>✗</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              }
              if (sepaOpen === u.userId) {
                rows.push(
                  <tr key={`sepa-${u.userId}`} style={{ background: "#f0f7ff" }}>
                    <td colSpan={6} style={{ padding: "0.75rem 1rem" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto", gap: "0.5rem", alignItems: "end" }}>
                        <div>
                          <label style={{ fontSize: "0.8rem", color: "#555" }}>IBAN</label>
                          <input type="text" placeholder="DE12 3456..." value={sepaForm.sepaIban}
                            onChange={e => setSepaForm(f => ({ ...f, sepaIban: e.target.value }))}
                            style={{ width: "100%", padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1.5px solid #bcd", fontFamily: "monospace", fontSize: "0.85rem", boxSizing: "border-box" }} />
                        </div>
                        <div>
                          <label style={{ fontSize: "0.8rem", color: "#555" }}>Mandatsreferenz</label>
                          <input type="text" placeholder="MAND-001" value={sepaForm.sepaMandatRef}
                            onChange={e => setSepaForm(f => ({ ...f, sepaMandatRef: e.target.value }))}
                            style={{ width: "100%", padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1.5px solid #bcd", fontSize: "0.85rem", boxSizing: "border-box" }} />
                        </div>
                        <div>
                          <label style={{ fontSize: "0.8rem", color: "#555" }}>Mandatsdatum</label>
                          <input type="date" value={sepaForm.sepaMandatDatum}
                            onChange={e => setSepaForm(f => ({ ...f, sepaMandatDatum: e.target.value }))}
                            style={{ width: "100%", padding: "0.3rem 0.5rem", borderRadius: "6px", border: "1.5px solid #bcd", fontSize: "0.85rem", boxSizing: "border-box" }} />
                        </div>
                        <div style={{ display: "flex", gap: "0.4rem" }}>
                          <button className="btn btn-success" disabled={sepaLoading}
                            onClick={() => saveSepa(u.userId)}
                            style={{ padding: "0.3rem 0.7rem", fontSize: "0.82rem", whiteSpace: "nowrap" }}>
                            {sepaLoading ? "..." : "💾 Speichern"}
                          </button>
                          {sepaMsg[u.userId] && <span style={{ color: "#2e7d32", fontSize: "0.82rem", alignSelf: "center" }}>{sepaMsg[u.userId]}</span>}
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              }
              return rows;
            })}
          </tbody>
        </table>
      )}
    </div>
    </>
  );
}

export default function Admin() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [bestellungen,    setBestellungen]    = useState([]);
  const [bestellungArchiv, setBestellungArchiv] = useState(false);
  const [rechnungArchiv,   setRechnungArchiv]   = useState(false);
  const [rechnungFilter,   setRechnungFilter]   = useState("offen");
  const [ebSuche,          setEbSuche]          = useState("");
  const [ebFilter,         setEbFilter]         = useState("offen");
  const initMonat = (() => { const h = new Date(); return `${h.getFullYear()}-${String(h.getMonth()+1).padStart(2,"0")}`; })();
  const [rechnungMonat,    setRechnungMonat]    = useState(initMonat);
  const [nachrichten,     setNachrichten]     = useState([]);
  const [besichtigungen,  setBesichtigungen]  = useState([]);
  const [rechnungen,      setRechnungen]      = useState([]);
  const [tagesbedarfHeute,   setTagesbedarfHeute]   = useState([]);
  const [tagesbedarfMorgen,  setTagesbedarfMorgen]  = useState([]);
  const [fahrerHeute,        setFahrerHeute]        = useState([]);
  const [fahrerMorgen,       setFahrerMorgen]       = useState([]);
  const [flaschen,           setFlaschen]           = useState([]);
  const [gutscheine,         setGutscheine]         = useState([]);
  const [rabattcodes,        setRabattcodes]        = useState([]);
  const [events,             setEvents]             = useState([]);
  const [analyse,            setAnalyse]            = useState(null);
  const [produkte,        setProdukte]        = useState([]);
  const [urlaub,          setUrlaub]          = useState([]);
  const [urlaubForm,      setUrlaubForm]      = useState({ urlaubVon: "", urlaubBis: "", beschreibung: "" });
  const [tab,             setTab]             = useState("bestellungen");
  const [loading,         setLoading]         = useState(true);
  const [filter,          setFilter]          = useState("aktiv");
  const [showMail,        setShowMail]        = useState(false);
  const [showWerbung,     setShowWerbung]     = useState(false);
  const [lieferpauschale,    setLieferpauschale]    = useState("1.60");
  const [lieferpauschaleMsg, setLieferpauschaleMsg] = useState(null);
  const [besichtigungPreis,  setBesichtigungPreis]  = useState("5.00");
  const [besichtigungPreisMsg, setBesichtigungPreisMsg] = useState(null);
  const [sepaHofIban,    setSepaHofIban]    = useState("");
  const [sepaHofBic,     setSepaHofBic]     = useState("");
  const [sepaGlaeubigerID, setSepaGlaeubigerID] = useState("");
  const [sepaMsg,        setSepaMsg]        = useState(null);
  const [touren,             setTouren]             = useState([]);
  const [flaschenTypen,      setFlaschenTypen]      = useState([]);
  const [news,               setNews]               = useState([]);
  const [showManuelleBestellung, setShowManuelleBestellung] = useState(false);
  const [showManuellesAbo,       setShowManuellesAbo]       = useState(false);
  const [bestellungSuche,    setBestellungSuche]    = useState("");

  useEffect(() => {
    if (!user?.isAdmin) { navigate("/"); return; }
    Promise.all([
      api.bestellungen.getAll(),
      api.nachrichten.getAll(),
      api.besichtigungen.getAll(),
      api.produkte.getAllAdmin(),
      api.betriebsurlaub.getAll(),
      api.rechnungen.getAll(initMonat),
      api.tagesbedarf.getByDatum(new Date().toISOString().slice(0,10)),
      api.tagesbedarf.getByDatum(new Date(Date.now() + 86400000).toISOString().slice(0,10)),
      api.flaschen.getAll(),
      api.gutscheine.getAll(),
      api.rabattcodes.getAll(),
      api.events.getAll(),
      api.analyse.getKpis(),
    ]).then(([b, n, bs, p, u, r, th, tm, fl, g, rc, ev, an]) => {
      setBestellungen(b); setNachrichten(n); setBesichtigungen(bs); setProdukte(p); setUrlaub(u); setRechnungen(r);
      setTagesbedarfHeute(th); setTagesbedarfMorgen(tm);
      setFlaschen(fl); setGutscheine(g); setRabattcodes(rc); setEvents(ev); setAnalyse(an);
    }).catch(err => console.error("Admin load error:", err))
      .finally(() => setLoading(false));
    api.einstellungen.get("Lieferpauschale").then(v => setLieferpauschale(v)).catch(() => {});
    api.einstellungen.get("BesichtigungPreis").then(v => setBesichtigungPreis(v)).catch(() => {});
    api.einstellungen.get("SepaHofIban").then(v => { if (v) setSepaHofIban(v); }).catch(() => {});
    api.einstellungen.get("SepaHofBic").then(v => { if (v) setSepaHofBic(v); }).catch(() => {});
    api.einstellungen.get("SepaGlaeubigerID").then(v => { if (v) setSepaGlaeubigerID(v); }).catch(() => {});
    api.touren.getAll().then(setTouren).catch(() => {});
    api.inventar.getFlaschenTypen().then(setFlaschenTypen).catch(() => {});
    api.news.getAll().then(setNews).catch(() => {});
  }, [user, navigate]);

  const statusAendern = async (id, status) => {
    await api.bestellungen.updateStatus(id, status);
    setBestellungen(prev => prev.map(b => b.bestellungId === id ? { ...b, status } : b));
  };

  const alsGelesen = async (id) => {
    await api.nachrichten.alsGelesen(id);
    setNachrichten(prev => prev.map(n => n.nachrichtId === id ? { ...n, gelesen: true } : n));
  };

  const nachrichtLoeschen = async (id) => {
    await api.nachrichten.delete(id);
    setNachrichten(prev => prev.filter(n => n.nachrichtId !== id));
  };

  const ARCHIV_STATUS = ["Gekündigt", "Abgeschlossen", "Fehlgeschlagen"];

  const gefilterteBestellungen = bestellungen.filter(b => {
    const istArchiv = ARCHIV_STATUS.includes(b.zahlungsStatus);
    if (bestellungArchiv && !istArchiv) return false;
    if (!bestellungArchiv && istArchiv) return false;
    if (filter === "aktiv")    { if (!b.istAktiv || b.pauseVon) return false; }
    else if (filter === "pausiert") { if (!b.pauseVon) return false; }
    else if (filter !== "alle") { if (b.intervall !== filter) return false; }
    if (bestellungSuche.trim()) {
      const q = bestellungSuche.toLowerCase();
      return (
        `${b.vorname} ${b.nachname}`.toLowerCase().includes(q) ||
        (b.email ?? "").toLowerCase().includes(q) ||
        (b.produktName ?? "").toLowerCase().includes(q) ||
        String(b.bestellungId).includes(q)
      );
    }
    return true;
  });

  if (loading) return <div className="loader">Daten werden geladen...</div>;

  return (
    <div className="container">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 className="section-title">👑 Admin-Bereich</h2>
        <div style={{ display: "flex", gap: "0.75rem" }}>
          <button className="btn btn-success" onClick={() => setShowMail(true)}>
            📧 Rundmail senden
          </button>
          <button className="btn" onClick={() => setShowWerbung(true)}
            style={{ background: "#e65100", color: "white" }}>
            📣 Werbemail senden
          </button>
        </div>
      </div>
      {showMail    && <MailModal    onClose={() => setShowMail(false)} />}
      {showWerbung && <WerbungModal onClose={() => setShowWerbung(false)} />}

      {/* ── Tabs ── */}
      <div style={{ display: "flex", gap: "0.75rem", margin: "1.5rem 0", flexWrap: "wrap" }}>
        <button className={`btn ${tab === "bestellungen" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("bestellungen")}>
          📦 Bestellungen ({bestellungen.filter(b => !["Aktiv","Gekündigt","Abgeschlossen","Fehlgeschlagen"].includes(b.zahlungsStatus)).length})
        </button>
        <button className={`btn ${tab === "einzelbestellungen" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("einzelbestellungen")}>
          🛒 Einzelbestellungen ({bestellungen.filter(b => b.intervall === "Einzelbestellung" && b.istAktiv).length})
        </button>
        <button className={`btn ${tab === "besichtigungen" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("besichtigungen")}>
          🐄 Besichtigungen ({besichtigungen.filter(b => b.status === "Ausstehend").length} neu)
        </button>
        <button className={`btn ${tab === "produkte" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("produkte")}>
          🥛 Produkte
        </button>
        <button className={`btn ${tab === "urlaub" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("urlaub")}>
          🏖️ Betriebsurlaub
        </button>
        <button className={`btn ${tab === "nachrichten" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("nachrichten")}>
          ✉️ Nachrichten ({nachrichten.filter(n => !n.gelesen).length} neu)
        </button>
        <button className={`btn ${tab === "rechnungen" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("rechnungen")}>
          🧾 Rechnungen ({rechnungen.filter(r => r.zahlungsstatus === "Offen").length} offen{rechnungen.filter(r => r.zahlungsstatus === "Entwurf").length > 0 ? `, ${rechnungen.filter(r => r.zahlungsstatus === "Entwurf").length} Entw.` : ""})
        </button>
        <button className={`btn ${tab === "tagesbedarf" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("tagesbedarf")}>
          📋 Tagesbedarf ({tagesbedarfHeute.length} heute)
        </button>
        <button className={`btn ${tab === "fahrer" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("fahrer")}>
          🚚 Lieferplan ({fahrerHeute.length} heute)
        </button>

        <button className={`btn ${tab === "flaschen" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("flaschen")}>
          🍼 Flaschen ({flaschen.filter(f => f.anzahl > 0).length} draußen)
        </button>
        <button className={`btn ${tab === "gutscheine" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("gutscheine")}>
          🎟️ Gutscheine ({gutscheine.filter(g => g.istAktiv).length} aktiv)
        </button>
        <button className={`btn ${tab === "rabattcodes" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("rabattcodes")}>
          🏷️ Rabattcodes ({rabattcodes.filter(r => r.istAktiv).length} aktiv)
        </button>
        <button className={`btn ${tab === "events" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("events")}>
          🎉 Events ({events.filter(e => e.istAktiv).length} aktiv)
        </button>
        <button className={`btn ${tab === "analyse" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("analyse")}>
          📊 Analyse
        </button>
        <button className={`btn ${tab === "einstellungen" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("einstellungen")}>
          ⚙️ Einstellungen
        </button>
        <button className={`btn ${tab === "touren" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("touren")}>
          🗺️ Touren
        </button>
        <button className={`btn ${tab === "news" ? "btn-success" : "btn-secondary"}`}
          onClick={() => setTab("news")}>
          📰 News ({news.filter(n => n.istAktiv).length} aktiv)
        </button>
      </div>

      {/* ── Bestellungen ── */}
      {tab === "bestellungen" && (
        <>
          {/* Manuelle Bestellung Button */}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem", marginBottom: "0.75rem" }}>
            <button className="btn btn-success" onClick={() => setShowManuelleBestellung(true)}
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              📞 Manuelle Bestellung
            </button>
            <button className="btn" onClick={() => setShowManuellesAbo(true)}
              style={{ background: "#1b5e20", color: "white", display: "flex", alignItems: "center", gap: "0.5rem" }}>
              📦 Manuelles Abo anlegen
            </button>
          </div>

          {/* Manuelle Bestellung Modal */}
          {showManuelleBestellung && (
            <ManuelleBestellungModal
              produkte={produkte}
              onClose={() => setShowManuelleBestellung(false)}
              onSuccess={() => {
                setShowManuelleBestellung(false);
                api.bestellungen.getAll().then(setBestellungen);
                api.rechnungen.getAll(rechnungMonat).then(setRechnungen);
              }}
            />
          )}

          {/* Manuelles Abo Modal */}
          {showManuellesAbo && (
            <ManuellesAboModal
              produkte={produkte}
              onClose={() => setShowManuellesAbo(false)}
              onSuccess={() => {
                setShowManuellesAbo(false);
                api.bestellungen.getAll().then(setBestellungen);
              }}
            />
          )}
          {/* Archiv-Toggle */}
          <div style={{ display: "flex", gap: "0.75rem", marginBottom: "0.75rem", alignItems: "center" }}>
            <button
              className={`btn ${!bestellungArchiv ? "btn-success" : "btn-secondary"}`}
              onClick={() => setBestellungArchiv(false)}
              style={{ padding: "0.35rem 1rem", fontSize: "0.88rem" }}>
              📋 Aktuelle ({bestellungen.filter(b => !ARCHIV_STATUS.includes(b.zahlungsStatus)).length})
            </button>
            <button
              className={`btn ${bestellungArchiv ? "btn-success" : "btn-secondary"}`}
              onClick={() => setBestellungArchiv(true)}
              style={{ padding: "0.35rem 1rem", fontSize: "0.88rem" }}>
              🗄️ Archiv ({bestellungen.filter(b => ARCHIV_STATUS.includes(b.zahlungsStatus)).length})
            </button>
          </div>

          {/* Filter */}
          <div style={{ display: "flex", gap: "0.5rem", marginBottom: "0.75rem", flexWrap: "wrap" }}>
            {["alle", "aktiv", "pausiert", "Einzelbestellung", "Wöchentlich", "2-wöchentlich", "Monatlich"].map(f => (
              <button key={f}
                onClick={() => setFilter(f)}
                className={`btn ${filter === f ? "btn-success" : "btn-secondary"}`}
                style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem" }}>
                {f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
          </div>

          {/* Suche */}
          <div style={{ marginBottom: "1rem", position: "relative" }}>
            <span style={{ position: "absolute", left: "0.75rem", top: "50%", transform: "translateY(-50%)", color: "#aaa" }}>🔍</span>
            <input
              type="text"
              placeholder="Suche nach Name, E-Mail, Produkt oder ID..."
              value={bestellungSuche}
              onChange={e => setBestellungSuche(e.target.value)}
              style={{ width: "100%", padding: "0.5rem 0.75rem 0.5rem 2.2rem", borderRadius: "8px", border: "1px solid #ddd", fontSize: "0.9rem", boxSizing: "border-box" }}
            />
            {bestellungSuche && (
              <button onClick={() => setBestellungSuche("")}
                style={{ position: "absolute", right: "0.75rem", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#aaa", fontSize: "1rem" }}>
                ✕
              </button>
            )}
          </div>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Kd.-Nr.</th>
                  <th>Kunde</th>
                  <th>Produkt</th>
                  <th>Menge</th>
                  <th>Intervall</th>
                  <th>Nächste Lieferung</th>
                  <th>Status</th>
                  <th>Zahlung</th>
                  <th>Pause</th>
                </tr>
              </thead>
              <tbody>
                {gefilterteBestellungen.map(b => {
                  // Nächste Lieferung berechnen
                  const naechste = (() => {
                    if (!b.intervall || b.intervall === "Einzelbestellung") return null;
                    const rohdatum = b.startDatum;
                    if (!rohdatum) return null;
                    const s = String(rohdatum);
                    const iso = s.slice(0, 10);
                    const de = s.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
                    const start = /^\d{4}-\d{2}-\d{2}$/.test(iso)
                      ? new Date(iso + "T00:00:00")
                      : de ? new Date(`${de[3]}-${de[2]}-${de[1]}T00:00:00`) : new Date(s);
                    if (isNaN(start.getTime())) return null;
                    const heute = new Date(); heute.setHours(0,0,0,0);
                    // DB-Wochentage (1=Mo … 7=So) → JS getDay() (0=So, 1=Mo … 6=Sa)
                    const tourTage = b.tourWochentage
                      ? b.tourWochentage.split(",").map(n => parseInt(n) % 7)
                      : null;
                    if (b.intervall === "Monatlich") {
                      // Ersten Tour-Tag (oder Mo falls keine Tour) des aktuellen/nächsten Monats
                      const zielTag = tourTage ? tourTage[0] : 1;
                      for (let moOffset = 0; moOffset <= 12; moOffset++) {
                        let d = new Date(heute.getFullYear(), heute.getMonth() + moOffset, 1);
                        while (d.getDay() !== zielTag) d.setDate(d.getDate() + 1);
                        if (d >= heute) return d;
                      }
                      return null;
                    }
                    const tage = b.intervall === "2-wöchentlich" ? 14 : 7;
                    let d = new Date(start);
                    while (d < heute) d.setDate(d.getDate() + tage);
                    return d;
                  })();
                  const parseDate = (val) => {
                    if (!val) return null;
                    const s = String(val);
                    // yyyy-MM-dd oder yyyy-MM-ddTHH:mm:ss
                    const iso = s.slice(0, 10);
                    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return new Date(iso + "T00:00:00");
                    // dd.MM.yyyy
                    const de = s.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
                    if (de) return new Date(`${de[3]}-${de[2]}-${de[1]}T00:00:00`);
                    const d = new Date(s);
                    return isNaN(d.getTime()) ? null : d;
                  };
                  const pauseVon = parseDate(b.pauseVon);
                  const pauseBis = parseDate(b.pauseBis);
                  const istPausiert = pauseVon && pauseBis && pauseVon <= new Date() && pauseBis >= new Date();
                  return (
                  <tr key={b.bestellungId} style={{ opacity: b.istAktiv ? 1 : 0.5 }}>
                    <td>#{b.bestellungId}</td>
                    <td style={{ color: "#888", fontSize: "0.85rem" }}>{b.kundennummer ?? "–"}</td>
                    <td>
                      <strong>{b.vorname} {b.nachname}</strong>
                      {b.rolle === "Firma" && (
                        <span style={{ marginLeft: "0.4rem", background: "#e3f2fd", color: "#1565c0", borderRadius: 5, padding: "0.1rem 0.4rem", fontSize: "0.72rem", fontWeight: 700 }}>Firma</span>
                      )}
                      <br /><small style={{ color: "#888" }}>{b.email}</small>
                    </td>
                    <td>{b.produktName ?? "–"} <small style={{ color: "#888" }}>{b.einheit}</small></td>
                    <td>{b.menge ?? "–"}</td>
                    <td>
                      <span className="badge" style={{
                        background: b.intervall === "Einzelbestellung" ? "#e3f2fd" : "#e8f5e9",
                        color: b.intervall === "Einzelbestellung" ? "#1565c0" : "#2e7d32"
                      }}>
                        {b.intervall ?? "–"}
                      </span>
                    </td>
                    <td style={{ fontWeight: 500, color: "#2e7d32" }}>
                      {naechste ? naechste.toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" }) : "–"}
                    </td>
                    <td>
                      {!b.istAktiv
                        ? <span className="badge" style={{ background: "#ffebee", color: "#c62828" }}>Beendet</span>
                        : istPausiert
                          ? <span className="badge" style={{ background: "#fff3e0", color: "#e65100" }}>⏸ Pausiert</span>
                          : <span className="badge" style={{ background: "#e8f5e9", color: "#2e7d32" }}>✓ Aktiv</span>
                      }
                    </td>
                    <td>
                      {(() => {
                        const s = b.zahlungsStatus;
                        const style = {
                          "Aktiv":          { background: "#e8f5e9", color: "#2e7d32" },
                          "Ausstehend":     { background: "#fff3e0", color: "#e65100" },
                          "Fehlgeschlagen": { background: "#ffebee", color: "#c62828" },
                          "Gekündigt":      { background: "#f5f5f5", color: "#888" },
                        }[s] ?? { background: "#f5f5f5", color: "#888" };
                        return <span className="badge" style={style}>{s ?? "–"}</span>;
                      })()}
                    </td>
                    <td style={{ fontSize: "0.85rem", color: "#888" }}>
                      {b.pauseVon ? (
                        pauseVon && pauseBis
                          ? `${pauseVon.toLocaleDateString("de-DE")} – ${pauseBis.toLocaleDateString("de-DE")}`
                          : (() => {
                              // Fallback: direkt aus Rohstring lesen
                              const fmt = (s) => {
                                if (!s) return "?";
                                const str = String(s);
                                // ISO: 2026-03-01 oder 2026-03-01T00:00:00
                                const iso = str.match(/(\d{4})-(\d{2})-(\d{2})/);
                                if (iso) return `${iso[3]}.${iso[2]}.${iso[1]}`;
                                // dd.MM.yyyy
                                const de2 = str.match(/(\d{2})\.(\d{2})\.(\d{4})/);
                                if (de2) return `${de2[1]}.${de2[2]}.${de2[3]}`;
                                // MM/dd/yyyy oder M/d/yyyy
                                const us = str.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
                                if (us) return `${String(us[2]).padStart(2,"0")}.${String(us[1]).padStart(2,"0")}.${us[3]}`;
                                return str.slice(0, 10);
                              };
                              return `${fmt(b.pauseVon)} – ${fmt(b.pauseBis)}`;
                            })()
                      ) : "–"}
                    </td>
                  </tr>
                  );
                })}
                {gefilterteBestellungen.length === 0 && (
                  <tr><td colSpan={9} style={{ textAlign: "center", color: "#888", padding: "2rem" }}>
                    Keine Bestellungen gefunden.
                  </td></tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ── Einzelbestellungen ── */}
      {tab === "einzelbestellungen" && (() => {
        const einzelne = bestellungen.filter(b => b.intervall === "Einzelbestellung");
        const gefiltert = einzelne.filter(b => {
          const q = ebSuche.trim().toLowerCase();
          const sucheOk = !q || `${b.vorname} ${b.nachname} ${b.email} ${b.produktName}`.toLowerCase().includes(q);
          const statusOk = ebFilter === "alle"
            ? true
            : ebFilter === "offen"
              ? b.istAktiv && b.zahlungsStatus !== "Abgeschlossen" && b.zahlungsStatus !== "Gekündigt"
              : !b.istAktiv || b.zahlungsStatus === "Abgeschlossen" || b.zahlungsStatus === "Gekündigt";
          return sucheOk && statusOk;
        });

        return (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem", flexWrap: "wrap", gap: "0.5rem" }}>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                {[
                  { key: "offen",        label: `📋 Offen (${einzelne.filter(b => b.istAktiv && b.zahlungsStatus !== "Abgeschlossen" && b.zahlungsStatus !== "Gekündigt").length})` },
                  { key: "abgeschlossen",label: `✓ Abgeschlossen (${einzelne.filter(b => !b.istAktiv || b.zahlungsStatus === "Abgeschlossen" || b.zahlungsStatus === "Gekündigt").length})` },
                  { key: "alle",         label: `Alle (${einzelne.length})` },
                ].map(({ key, label }) => (
                  <button key={key}
                    className={`btn ${ebFilter === key ? "btn-success" : "btn-secondary"}`}
                    onClick={() => setEbFilter(key)}
                    style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem" }}>
                    {label}
                  </button>
                ))}
              </div>
              <input
                type="text" placeholder="🔍 Name, E-Mail, Produkt..."
                value={ebSuche} onChange={e => setEbSuche(e.target.value)}
                style={{ padding: "0.4rem 0.75rem", borderRadius: "8px", border: "1px solid #ddd", fontSize: "0.88rem", minWidth: 220 }}
              />
            </div>

            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Kunde</th>
                    <th>Produkt</th>
                    <th>Menge</th>
                    <th>Lieferdatum</th>
                    <th>Adresse</th>
                    <th>Status</th>
                    <th>Notiz</th>
                    <th>Rechnung</th>
                  </tr>
                </thead>
                <tbody>
                  {gefiltert.map(b => {
                    const abgeschlossen = !b.istAktiv || b.zahlungsStatus === "Abgeschlossen" || b.zahlungsStatus === "Gekündigt";
                    return (
                      <tr key={b.bestellungId} style={{ opacity: abgeschlossen ? 0.55 : 1, background: abgeschlossen ? "#fafafa" : "white" }}>
                        <td style={{ fontSize: "0.82rem", fontFamily: "monospace" }}>#{b.bestellungId}</td>
                        <td>
                          <strong>{b.vorname} {b.nachname}</strong>
                          {b.kundennummer && <span style={{ marginLeft: "0.4rem", fontSize: "0.75rem", color: "#aaa" }}>#{b.kundennummer}</span>}
                          <br /><small style={{ color: "#888" }}>{b.email}</small>
                        </td>
                        <td>{b.produktName ?? "–"} <small style={{ color: "#888" }}>{b.einheit}</small></td>
                        <td>{b.menge ?? "–"}</td>
                        <td style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                          {b.startDatum ? new Date(b.startDatum + "T00:00:00").toLocaleDateString("de-DE") : "–"}
                        </td>
                        <td style={{ fontSize: "0.82rem", color: "#555" }}>
                          {b.strasse ? <>{b.strasse}<br />{b.plz} {b.ort}</> : "–"}
                        </td>
                        <td>
                          {abgeschlossen
                            ? <span style={{ background: "#f5f5f5", color: "#888", padding: "0.15rem 0.5rem", borderRadius: "5px", fontSize: "0.8rem" }}>Abgeschlossen</span>
                            : <span style={{ background: "#e8f5e9", color: "#2e7d32", padding: "0.15rem 0.5rem", borderRadius: "5px", fontSize: "0.8rem", fontWeight: 600 }}>Offen</span>
                          }
                        </td>
                        <td style={{ fontSize: "0.82rem", color: "#888", maxWidth: 160, whiteSpace: "pre-wrap" }}>{b.notiz ?? "–"}</td>
                        <td>
                          {!abgeschlossen && (
                            <button
                              style={{ padding: "0.25rem 0.65rem", fontSize: "0.78rem", background: "#e8f5e9", color: "#2e7d32", border: "1px solid #a5d6a7", borderRadius: "6px", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}
                              onClick={() => {
                                // ManuelleRechnungButton vorbelegen – öffne direkt mit Daten
                                const betrag = b.gesamtpreis > 0 ? b.gesamtpreis : (b.menge ?? 1) * (b.preis ?? 0);
                                const url = `${process.env.REACT_APP_API_URL}/rechnungen/manuell`;
                                const dto = {
                                  userId:       b.userId,
                                  beschreibung: `${b.produktName} (Einzelbestellung #${b.bestellungId})`,
                                  menge:        b.menge ?? 1,
                                  einheit:      b.einheit ?? "Stk.",
                                  betrag:       betrag,
                                  sendMail:     false,
                                };
                                fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(dto) })
                                  .then(async r => {
                                    if (!r.ok) throw new Error("Fehler beim Erstellen");
                                    // PDF in neuem Tab öffnen
                                    const blob = await r.blob();
                                    const objUrl = URL.createObjectURL(blob);
                                    window.open(objUrl, "_blank");
                                    api.rechnungen.getAll(rechnungMonat).then(setRechnungen);
                                    alert("✓ Rechnung erstellt! PDF wurde geöffnet.");
                                  })
                                  .catch(e => alert(e.message ?? "Fehler"));
                              }}>
                              📄 Rechnung erstellen
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {gefiltert.length === 0 && (
                    <tr><td colSpan={9} style={{ textAlign: "center", color: "#888", padding: "2rem" }}>
                      Keine Einzelbestellungen gefunden.
                    </td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      })()}

      {/* ── Besichtigungen ── */}
      {tab === "besichtigungen" && (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr><th>ID</th><th>Kunde</th><th>Datum</th><th>Uhrzeit</th><th>Personen</th><th>Nachricht</th><th>Status</th><th>Aktion</th></tr>
            </thead>
            <tbody>
              {besichtigungen.map(b => (
                <BesichtigungRow key={b.besichtigungId} b={b}
                  onUpdate={(id, status, nachricht) => {
                    api.besichtigungen.updateStatus(id, { status, adminNachricht: nachricht });
                    setBesichtigungen(prev => prev.map(x => x.besichtigungId === id ? { ...x, status } : x));
                  }}
                  onDelete={async (id) => {
                    await api.besichtigungen.delete(id);
                    setBesichtigungen(prev => prev.filter(x => x.besichtigungId !== id));
                  }}
                />
              ))}
              {besichtigungen.length === 0 && (
                <tr><td colSpan={8} style={{ textAlign: "center", color: "#888", padding: "2rem" }}>
                  Keine Besichtigungsanfragen.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Produkte ── */}
      {tab === "produkte" && (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr><th>ID</th><th>Name</th><th>Preis</th><th>Einheit</th><th>Status</th><th>Aktion</th></tr>
            </thead>
            <tbody>
              {produkte.map(p => (
                <ProduktRow key={p.produktId} p={p} onUpdate={(id, feld, val) => {
                  setProdukte(prev => prev.map(x => x.produktId === id ? { ...x, [feld]: val } : x));
                }} />
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Betriebsurlaub ── */}
      {tab === "urlaub" && (
        <div>
          <div className="card" style={{ border: "1.5px solid #ffe0b2", marginBottom: "1.5rem" }}>
            <h3 style={{ color: "#e65100", marginBottom: "1rem" }}>🏖️ Betriebsurlaub eintragen</h3>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 2fr", gap: "0 1rem" }}>
              <div className="form-group">
                <label>Von *</label>
                <input type="date" value={urlaubForm.urlaubVon} min={new Date().toISOString().slice(0,10)}
                  onChange={e => setUrlaubForm({ ...urlaubForm, urlaubVon: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Bis *</label>
                <input type="date" value={urlaubForm.urlaubBis} min={urlaubForm.urlaubVon || new Date().toISOString().slice(0,10)}
                  onChange={e => setUrlaubForm({ ...urlaubForm, urlaubBis: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Beschreibung</label>
                <input type="text" value={urlaubForm.beschreibung} placeholder="z.B. Sommerurlaub"
                  onChange={e => setUrlaubForm({ ...urlaubForm, beschreibung: e.target.value })} />
              </div>
            </div>
            <button className="btn" style={{ background: "#e65100", color: "white" }}
              onClick={async () => {
                if (!urlaubForm.urlaubVon || !urlaubForm.urlaubBis) return;
                const neu = await api.betriebsurlaub.create(urlaubForm);
                const frisch = await api.betriebsurlaub.getAll();
                setUrlaub(frisch);
                setUrlaubForm({ urlaubVon: "", urlaubBis: "", beschreibung: "" });
              }}>
              🏖️ Urlaub eintragen
            </button>
          </div>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr><th>Von</th><th>Bis</th><th>Beschreibung</th><th>Aktion</th></tr>
              </thead>
              <tbody>
                {urlaub.map(u => (
                  <tr key={u.urlaubId}>
                    <td>{u.urlaubVon ? new Date(u.urlaubVon.slice(0,10) + "T00:00:00").toLocaleDateString("de-DE") : "–"}</td>
                    <td>{u.urlaubBis ? new Date(u.urlaubBis.slice(0,10) + "T00:00:00").toLocaleDateString("de-DE") : "–"}</td>
                    <td>{u.beschreibung ?? "–"}</td>
                    <td>
                      <button className="btn" style={{ background: "#c62828", color: "white", padding: "0.3rem 0.8rem", fontSize: "0.85rem" }}
                        onClick={() => {
                          api.betriebsurlaub.delete(u.urlaubId);
                          setUrlaub(prev => prev.filter(x => x.urlaubId !== u.urlaubId));
                        }}>
                        🗑️ Löschen
                      </button>
                    </td>
                  </tr>
                ))}
                {urlaub.length === 0 && (
                  <tr><td colSpan={4} style={{ textAlign: "center", color: "#888", padding: "2rem" }}>Kein Betriebsurlaub eingetragen.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── Rechnungen ── */}
      {tab === "rechnungen" && (() => {
        const aktuellerMonat = initMonat;
        const istGemahnt   = r => (r.mahnStufe ?? 0) > 0 && r.zahlungsstatus !== "Bezahlt";
        const entwuerfe    = rechnungen.filter(r => r.zahlungsstatus === "Entwurf");
        const offeneAlt    = rechnungen.filter(r => {
          const [d, m, y]  = (r.erstelltAm ?? "").split(".");
          return r.zahlungsstatus !== "Bezahlt" && r.zahlungsstatus !== "Entwurf" && `${y}-${m}` < aktuellerMonat;
        });
        const diesenMonat  = rechnungen.filter(r => {
          const [d, m, y]  = (r.erstelltAm ?? "").split(".");
          return `${y}-${m}` === (rechnungMonat || aktuellerMonat) && r.zahlungsstatus !== "Entwurf";
        });
        // Standardansicht: aktueller Monat + offene Altrechnungen (ohne Entwürfe)
        // Monatsauswahl: nur der gewählte Monat (ohne Entwürfe)
        const basis = rechnungMonat
          ? rechnungen.filter(r => r.zahlungsstatus !== "Entwurf")
          : [...offeneAlt, ...diesenMonat];

        const anzAlle    = basis.length;
        const anzOffen   = basis.filter(r => r.zahlungsstatus !== "Bezahlt" && !istGemahnt(r)).length;
        const anzGemahnt = basis.filter(istGemahnt).length;
        const anzBezahlt = basis.filter(r => r.zahlungsstatus === "Bezahlt").length;

        const gefiltertRechnungen = basis.filter(r => {
          if (rechnungFilter === "offen")   return r.zahlungsstatus !== "Bezahlt" && !istGemahnt(r);
          if (rechnungFilter === "gemahnt") return istGemahnt(r);
          if (rechnungFilter === "bezahlt") return r.zahlungsstatus === "Bezahlt";
          return true;
        });

        const reload = () => api.rechnungen.getAll(rechnungMonat).then(setRechnungen);

        return (
        <div>
          {/* ── Toolbar ── */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem", flexWrap: "wrap", gap: "0.75rem" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap" }}>
              {[
                { key: "alle",    label: `Alle (${anzAlle})` },
                { key: "offen",   label: `📋 Offen (${anzOffen})` },
                { key: "gemahnt", label: `📨 Gemahnt (${anzGemahnt})` },
                { key: "bezahlt", label: `✓ Bezahlt (${anzBezahlt})` },
              ].map(({ key, label }) => (
                <button key={key}
                  className={`btn ${rechnungFilter === key ? "btn-success" : "btn-secondary"}`}
                  onClick={() => setRechnungFilter(key)}
                  style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem" }}>
                  {label}
                </button>
              ))}
              <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <label style={{ fontSize: "0.82rem", color: "#888" }}>Monat:</label>
                <input type="month" value={rechnungMonat}
                  onChange={e => {
                    setRechnungMonat(e.target.value);
                    api.rechnungen.getAll(e.target.value).then(setRechnungen);
                  }}
                  style={{ padding: "0.3rem 0.5rem", borderRadius: "7px", border: "1.5px solid #ddd", fontSize: "0.85rem" }} />
                {rechnungMonat !== aktuellerMonat && (
                  <button onClick={() => {
                    setRechnungMonat(aktuellerMonat);
                    api.rechnungen.getAll(aktuellerMonat).then(setRechnungen);
                  }} style={{ fontSize: "0.8rem", color: "#888", background: "none", border: "1px solid #ddd", borderRadius: "6px", padding: "0.2rem 0.5rem", cursor: "pointer" }}>
                    Aktueller Monat
                  </button>
                )}
              </div>
            </div>
            <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
              <a href={api.rechnungen.painExport()} target="_blank" rel="noreferrer"
                style={{ padding: "0.3rem 0.8rem", fontSize: "0.85rem", background: "#e8eaf6", color: "#283593", border: "1.5px solid #9fa8da", borderRadius: "8px", textDecoration: "none", display: "flex", alignItems: "center", fontWeight: 600 }}>
                💳 PAIN
              </a>
              <CamtImportButton onSuccess={reload} />
              <ManuelleRechnungButton kunden={bestellungen} onSuccess={reload} />
              <button className="btn" onClick={async () => {
                if (!window.confirm("Monatsrechnungen für den aktuellen Monat als Entwurf generieren?")) return;
                try { const res = await api.rechnungen.monatlichVersenden(); alert(`✓ ${res.meldung}`); reload(); }
                catch { alert("Fehler beim Generieren."); }
              }} style={{ background: "#6a1b9a", color: "white", padding: "0.3rem 0.8rem", fontSize: "0.85rem", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: 600 }}>
                📝 Entwürfe generieren
              </button>
            </div>
          </div>

          {entwuerfe.length > 0 && (
            <div style={{ background: "#f3e5f5", border: "1.5px solid #ce93d8", borderRadius: "10px", padding: "1rem", marginBottom: "1rem" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" }}>
                <h3 style={{ margin: 0, color: "#6a1b9a", fontSize: "1rem" }}>
                  📝 Entwürfe ({entwuerfe.length}) – noch nicht versendet
                </h3>
                <button onClick={async () => {
                  if (!window.confirm(`Alle ${entwuerfe.length} Entwürfe freigeben und per E-Mail versenden?`)) return;
                  try {
                    const res = await api.rechnungen.alleFreigeben();
                    alert(`✓ ${res.meldung}`);
                    reload();
                  } catch (e) { alert(e.message ?? "Fehler beim Freigeben."); }
                }} style={{ background: "#6a1b9a", color: "white", padding: "0.35rem 0.9rem", fontSize: "0.85rem", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: 600 }}>
                  ✅ Alle freigeben & versenden
                </button>
              </div>
              <div className="table-wrapper" style={{ marginBottom: 0 }}>
                <table>
                  <thead>
                    <tr>
                      <th>Rechnungsnr.</th>
                      <th>Kunde</th>
                      <th>Monat</th>
                      <th>Betrag</th>
                      <th>Zahlung</th>
                      <th>Aktion</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entwuerfe.map(r => (
                      <tr key={r.rechnungId} style={{ background: "#fdf6ff" }}>
                        <td style={{ fontSize: "0.82rem", fontFamily: "monospace" }}>#{String(r.rechnungId).padStart(6, "0")}</td>
                        <td>
                          <strong>{r.vorname} {r.nachname}</strong>
                          {r.kundennummer && <span style={{ marginLeft: "0.4rem", fontSize: "0.75rem", color: "#aaa" }}>#{r.kundennummer}</span>}
                          <br /><small style={{ color: "#888" }}>{r.email}</small>
                        </td>
                        <td style={{ fontSize: "0.85rem" }}>{r.monatJahr ?? r.erstelltAm}</td>
                        <td style={{ fontWeight: 600, whiteSpace: "nowrap" }}>{(r.betrag ?? 0).toFixed(2)} €</td>
                        <td style={{ fontSize: "0.8rem" }}>
                          {r.zahlungsmethode === "Lastschrift"
                            ? <span style={{ background: "#e3f2fd", color: "#1565c0", padding: "0.15rem 0.5rem", borderRadius: "6px", fontWeight: 600 }}>🏦 Lastschrift</span>
                            : <span style={{ background: "#f5f5f5", color: "#777", padding: "0.15rem 0.5rem", borderRadius: "6px" }}>Überweisung</span>}
                        </td>
                        <td>
                          <div style={{ display: "flex", gap: "0.35rem", flexWrap: "wrap" }}>
                            <a href={api.rechnungen.pdf(r.rechnungId)} target="_blank" rel="noreferrer"
                              style={{ padding: "0.25rem 0.55rem", fontSize: "0.78rem", background: "#e3f2fd", color: "#1565c0", border: "1px solid #90caf9", borderRadius: "6px", textDecoration: "none" }}>
                              📄 Prüfen
                            </a>
                            <button style={{ padding: "0.25rem 0.7rem", fontSize: "0.78rem", background: "#e8f5e9", color: "#2e7d32", border: "1px solid #a5d6a7", borderRadius: "6px", cursor: "pointer", fontWeight: 600 }}
                              onClick={async () => {
                                try {
                                  const res = await api.rechnungen.freigeben(r.rechnungId);
                                  alert(res.mailGesendet ? "✓ Freigegeben & Mail gesendet!" : `✓ Freigegeben (Mail: ${res.hinweis ?? "fehlgeschlagen"})`);
                                  reload();
                                } catch (e) { alert(e.message ?? "Fehler"); }
                              }}>✅ Freigeben</button>
                            <button style={{ padding: "0.25rem 0.5rem", fontSize: "0.78rem", background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "6px", cursor: "pointer" }}
                              onClick={async () => {
                                if (!window.confirm("Entwurf löschen?")) return;
                                await api.rechnungen.delete(r.rechnungId);
                                setRechnungen(prev => prev.filter(x => x.rechnungId !== r.rechnungId));
                              }}>🗑️</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {!rechnungMonat && offeneAlt.length > 0 && (
            <div style={{ background: "#fff3e0", border: "1.5px solid #ffb74d", borderRadius: "8px", padding: "0.5rem 1rem", marginBottom: "0.75rem", fontSize: "0.88rem", color: "#e65100" }}>
              ⚠ {offeneAlt.length} unbezahlte Rechnung{offeneAlt.length !== 1 ? "en" : ""} aus Vormonaten
            </div>
          )}

          {/* ── Tabelle ── */}
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Rechnungsnr.</th>
                  <th>Kunde</th>
                  <th>Rechnungsdatum</th>
                  <th>Fällig am</th>
                  <th>Betrag</th>
                  <th>Offener Betrag</th>
                  <th>Status</th>
                  <th>Mahnstufe</th>
                  <th>Zahlung</th>
                  <th>Aktion</th>
                </tr>
              </thead>
              <tbody>
                {gefiltertRechnungen.map(r => {
                  const gemahnt      = (r.mahnStufe ?? 0) > 0;
                  const gesamtBetrag = (r.betrag ?? 0) + (r.mahnGebuehr ?? 0);
                  const offenerBetrag = r.zahlungsstatus === "Bezahlt" ? 0 : gesamtBetrag;
                  const istAlt       = (() => { const [d,m,y] = (r.erstelltAm??"").split("."); return `${y}-${m}` < aktuellerMonat; })();
                  const zeilenBg     = r.zahlungsstatus === "Bezahlt" ? "#fafafa" : istAlt ? "#fffde7" : "white";
                  const statusFarbe  = r.zahlungsstatus === "Bezahlt" ? { bg: "#e8f5e9", color: "#2e7d32" }
                                     : gemahnt                        ? { bg: "#fce4ec", color: "#ad1457" }
                                                                       : { bg: "#fff3e0", color: "#e65100" };
                  return (
                    <tr key={r.rechnungId} style={{ background: zeilenBg }}>
                      <td style={{ fontSize: "0.82rem", fontFamily: "monospace" }}>
                        #{String(r.rechnungId).padStart(6, "0")}
                        {istAlt && r.zahlungsstatus !== "Bezahlt" && <div style={{ fontSize: "0.72rem", color: "#f57c00", fontWeight: 600 }}>Vormonat</div>}
                      </td>
                      <td>
                        <strong>{r.vorname} {r.nachname}</strong>
                        {r.kundennummer && <span style={{ marginLeft: "0.4rem", fontSize: "0.75rem", color: "#aaa" }}>#{r.kundennummer}</span>}
                        <br /><small style={{ color: "#888" }}>{r.email}</small>
                      </td>
                      <td style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>{r.erstelltAm ?? "–"}</td>
                      <td style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                        {r.faelligAm ? new Date(r.faelligAm + "T00:00:00").toLocaleDateString("de-DE") : "–"}
                      </td>
                      <td style={{ whiteSpace: "nowrap", fontWeight: 600 }}>{gesamtBetrag.toFixed(2)} €</td>
                      <td style={{ whiteSpace: "nowrap", fontWeight: 600, color: offenerBetrag > 0 ? "#e65100" : "#2e7d32" }}>
                        {offenerBetrag.toFixed(2)} €
                      </td>
                      <td>
                        <span style={{ background: statusFarbe.bg, color: statusFarbe.color, padding: "0.15rem 0.55rem", borderRadius: "6px", fontSize: "0.8rem", fontWeight: 600, whiteSpace: "nowrap" }}>
                          {r.zahlungsstatus}
                        </span>
                      </td>
                      <td style={{ textAlign: "center", fontSize: "0.85rem" }}>
                        {(r.mahnStufe ?? 0) > 0
                          ? <span style={{ color: "#c62828", fontWeight: 700 }}>Stufe {r.mahnStufe}</span>
                          : <span style={{ color: "#ccc" }}>–</span>}
                      </td>
                      <td style={{ textAlign: "center", fontSize: "0.8rem", whiteSpace: "nowrap" }}>
                        {r.zahlungsmethode === "Lastschrift"
                          ? <span style={{ background: "#e3f2fd", color: "#1565c0", padding: "0.15rem 0.5rem", borderRadius: "6px", fontWeight: 600 }}>🏦 Lastschrift</span>
                          : <span style={{ background: "#f5f5f5", color: "#777", padding: "0.15rem 0.5rem", borderRadius: "6px" }}>Überweisung</span>}
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: "0.35rem", flexWrap: "wrap" }}>
                          {r.zahlungsstatus !== "Bezahlt" && (
                            <button className="btn btn-success" style={{ padding: "0.25rem 0.55rem", fontSize: "0.78rem" }}
                              onClick={async () => {
                                await api.rechnungen.updateStatus(r.rechnungId, "Bezahlt");
                                setRechnungen(prev => prev.map(x => x.rechnungId === r.rechnungId ? { ...x, zahlungsstatus: "Bezahlt" } : x));
                              }}>✓ Bezahlt</button>
                          )}
                          {r.zahlungsstatus !== "Bezahlt" && (r.mahnStufe ?? 0) < 3 && (
                            <button style={{ padding: "0.25rem 0.55rem", fontSize: "0.78rem", background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "6px", cursor: "pointer", fontWeight: 600 }}
                              onClick={async () => {
                                if (!window.confirm(`Mahnung Stufe ${(r.mahnStufe ?? 0) + 1} senden?`)) return;
                                try {
                                  const res = await api.rechnungen.mahnen(r.rechnungId);
                                  alert(`✓ Mahnung Stufe ${res.mahnStufe} ${res.mailGesendet ? "gesendet" : "(Mail fehlgeschlagen)"}`);
                                  reload();
                                } catch (e) { alert(e.message ?? "Fehler"); }
                              }}>⚠ Mahnen</button>
                          )}
                          <a href={api.rechnungen.pdf(r.rechnungId)} target="_blank" rel="noreferrer"
                            style={{ padding: "0.25rem 0.55rem", fontSize: "0.78rem", background: "#e3f2fd", color: "#1565c0", border: "1px solid #90caf9", borderRadius: "6px", textDecoration: "none", display: "inline-flex", alignItems: "center" }}>
                            📄</a>
                          <button style={{ padding: "0.25rem 0.55rem", fontSize: "0.78rem", background: "#f3e5f5", color: "#6a1b9a", border: "1px solid #ce93d8", borderRadius: "6px", cursor: "pointer" }}
                            onClick={async () => {
                              try { await api.rechnungen.sendMail(r.rechnungId); alert(`✓ Mail gesendet!`); }
                              catch { alert("Fehler beim Senden."); }
                            }}>✉️</button>
                          <button style={{ padding: "0.25rem 0.5rem", fontSize: "0.78rem", background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "6px", cursor: "pointer" }}
                            onClick={async () => {
                              if (!window.confirm("Rechnung löschen?")) return;
                              await api.rechnungen.delete(r.rechnungId);
                              setRechnungen(prev => prev.filter(x => x.rechnungId !== r.rechnungId));
                            }}>🗑️</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {gefiltertRechnungen.length === 0 && (
                  <tr><td colSpan={9} style={{ textAlign: "center", color: "#888", padding: "2rem" }}>
                    Keine Rechnungen in dieser Ansicht.
                  </td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        );
      })()}

      {/* ── Tagesbedarf ── */}
      {tab === "tagesbedarf" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.5rem", marginTop: "1rem" }}>
          {[
            { label: "📋 Heute", datum: new Date(), daten: tagesbedarfHeute },
            { label: "📋 Morgen", datum: new Date(Date.now() + 86400000), daten: tagesbedarfMorgen },
          ].map(({ label, datum, daten }) => (
            <div key={label}>
              <h3 style={{ color: "#2e7d32", marginBottom: "0.75rem" }}>
                {label} – {datum.toLocaleDateString("de-DE", { weekday: "long", day: "2-digit", month: "long" })}
                <span style={{ marginLeft: "0.75rem", fontSize: "0.9rem", color: "#888", fontWeight: 400 }}>
                  {daten.length} Bestellung{daten.length !== 1 ? "en" : ""}
                </span>
              </h3>
              {daten.length === 0
                ? <div className="card" style={{ textAlign: "center", color: "#aaa" }}>Keine Bestellungen.</div>
                : (() => {
                  // Nach Tour gruppieren
                  const touren = {};
                  daten.forEach(b => {
                    const key = b.tourName ?? "Ohne Tour";
                    if (!touren[key]) touren[key] = { farbe: b.tourFarbe ?? "#888", eintraege: [] };
                    touren[key].eintraege.push(b);
                  });
                  return (
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      {Object.entries(touren).map(([tourName, { farbe, eintraege }]) => {
                        // Gesamtmenge pro Produkt
                        const summen = {};
                        eintraege.forEach(b => {
                          const key = `${b.produktName}|${b.einheit}`;
                          summen[key] = (summen[key] ?? 0) + (b.menge ?? 0);
                        });
                        return (
                          <div key={tourName}>
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.4rem" }}>
                              <span style={{ width: 10, height: 10, borderRadius: "50%", background: farbe, flexShrink: 0, display: "inline-block" }} />
                              <strong style={{ color: farbe }}>{tourName}</strong>
                              <span style={{ color: "#888", fontSize: "0.82rem" }}>{eintraege.length} Stopps</span>
                              <span style={{ marginLeft: "auto", fontSize: "0.82rem", color: "#555" }}>
                                {Object.entries(summen).map(([k, m]) => {
                                  const [name, einheit] = k.split("|");
                                  return <span key={k} style={{ marginLeft: "0.5rem", fontWeight: 600 }}>📦 {m} {einheit} {name}</span>;
                                })}
                              </span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
                              {eintraege.map(b => (
                                <div key={b.bestellungId} className="card"
                                  style={{ padding: "0.6rem 0.9rem", borderLeft: `3px solid ${farbe}` }}>
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div>
                                      <strong>{b.vorname} {b.nachname}</strong>
                                      <span style={{ color: "#888", fontSize: "0.82rem", marginLeft: "0.5rem" }}>{b.email}</span>
                                    </div>
                                    <span className="badge" style={{ background: "#e8f5e9", color: "#2e7d32", fontSize: "0.78rem" }}>
                                      {b.intervall ?? "Einzelbestellung"}
                                    </span>
                                  </div>
                                  <div style={{ marginTop: "0.3rem", color: "#555", fontSize: "0.9rem" }}>
                                    🛒 <strong>{b.menge} {b.einheit}</strong> {b.produktName}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })()
              }
            </div>
          ))}
        </div>
      )}

      {/* ── Analyse ── */}
      {tab === "analyse" && <AnalyseTab analyse={analyse} />}

      {/* ── Events ── */}
      {tab === "events" && (
        <EventsTab events={events} setEvents={setEvents} />
      )}

      {/* ── Rabattcodes ── */}
      {tab === "rabattcodes" && (
        <RabattcodesTab rabattcodes={rabattcodes} setRabattcodes={setRabattcodes} />
      )}

      {/* ── Gutscheine ── */}
      {tab === "gutscheine" && (
        <GutscheineTab gutscheine={gutscheine} setGutscheine={setGutscheine} />
      )}

      {/* ── Flaschen ── */}
      {tab === "flaschen" && (
        <FlaschenTab flaschen={flaschen} setFlaschen={setFlaschen} flaschenTypen={flaschenTypen} setFlaschenTypen={setFlaschenTypen} />
      )}

      {/* ── Fahrer / Lieferplan ── */}
      {tab === "fahrer" && (
        <div style={{ marginTop: "1rem" }}>
          <div style={{ textAlign: "center", padding: "3rem", color: "#888" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🚚</div>
            <p>Der Lieferplan wurde auf die neue Tour-basierte Fahrerseite umgestellt.</p>
            <a href="/fahrer" className="btn btn-success" style={{ marginTop: "0.5rem", display: "inline-block" }}>
              → Zur Fahrerseite
            </a>
          </div>
        </div>
      )}

      {/* ── Nachrichten ── */}
      {tab === "nachrichten" && (
        <div className="card-grid">
          {nachrichten.length === 0 && (
            <div style={{ gridColumn: "1/-1", textAlign: "center", color: "#aaa", padding: "2rem" }}>Keine Nachrichten.</div>
          )}
          {nachrichten.map(n => (
            <div className="card" key={n.nachrichtId} style={{ opacity: n.gelesen ? 0.6 : 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <strong>{n.name}</strong>
                <div style={{ display: "flex", gap: "0.4rem", alignItems: "center" }}>
                  {!n.gelesen && <span className="badge" style={{ background: "#fff3e0", color: "#e65100" }}>Neu</span>}
                  <button onClick={() => nachrichtLoeschen(n.nachrichtId)}
                    style={{ background: "none", border: "none", cursor: "pointer", color: "#e57373", fontSize: "1.1rem", padding: "0 0.2rem" }}>
                    🗑️
                  </button>
                </div>
              </div>
              <small style={{ color: "#888" }}>{n.email} · {n.erhaltenAm ? new Date(n.erhaltenAm).toLocaleDateString("de-DE") : ""}</small>
              {n.betreff && <p style={{ fontWeight: 600, marginTop: "0.5rem" }}>{n.betreff}</p>}
              <p style={{ marginTop: "0.5rem", fontSize: "0.9rem" }}>{n.inhalt}</p>
              {!n.gelesen && (
                <button className="btn btn-secondary"
                  style={{ marginTop: "0.75rem", padding: "0.4rem 1rem", fontSize: "0.85rem" }}
                  onClick={() => alsGelesen(n.nachrichtId)}>
                  Als gelesen markieren
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {/* ── Inventar ── */}
      {tab === "touren" && (
        <TourenTab touren={touren} setTouren={setTouren} />
      )}

      {tab === "einstellungen" && (
        <div className="card" style={{ maxWidth: 480 }}>
          <h3 style={{ color: "#2e7d32", marginBottom: "1.25rem" }}>⚙️ Einstellungen</h3>

          <div className="form-group">
            <label>🚚 Lieferpauschale (€)</label>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <input type="number" step="0.01" min="0" value={lieferpauschale}
                onChange={e => { setLieferpauschale(e.target.value); setLieferpauschaleMsg(null); }}
                style={{ flex: 1 }} />
              <button className="btn btn-success" style={{ whiteSpace: "nowrap" }}
                onClick={async () => {
                  await api.einstellungen.update("Lieferpauschale", lieferpauschale);
                  setLieferpauschaleMsg("✓ Gespeichert!");
                  setTimeout(() => setLieferpauschaleMsg(null), 3000);
                }}>Speichern</button>
            </div>
            {lieferpauschaleMsg && <small style={{ color: "#2e7d32" }}>{lieferpauschaleMsg}</small>}
            <small style={{ color: "#888" }}>Wird bei jeder Lieferung auf den Bestellpreis addiert. Bei Abholung entfällt sie.</small>
          </div>

          <hr style={{ margin: "1.5rem 0", borderColor: "#eee" }} />

          <div className="form-group">
            <label>🐄 Besichtigung Eintrittsgebühr (€)</label>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <input type="number" step="0.50" min="0" value={besichtigungPreis}
                onChange={e => { setBesichtigungPreis(e.target.value); setBesichtigungPreisMsg(null); }}
                style={{ flex: 1 }} />
              <button className="btn btn-success" style={{ whiteSpace: "nowrap" }}
                onClick={async () => {
                  await api.einstellungen.update("BesichtigungPreis", besichtigungPreis);
                  setBesichtigungPreisMsg("✓ Gespeichert!");
                  setTimeout(() => setBesichtigungPreisMsg(null), 3000);
                }}>Speichern</button>
            </div>
            {besichtigungPreisMsg && <small style={{ color: "#2e7d32" }}>{besichtigungPreisMsg}</small>}
            <small style={{ color: "#888" }}>Kunden <strong>ohne aktives Abo</strong> zahlen diesen Preis pro Person. Kunden mit Abo kommen kostenlos rein.</small>
          </div>

          <hr style={{ margin: "1.25rem 0", border: "none", borderTop: "1.5px solid #e0e0e0" }} />
          <h4 style={{ color: "#1565c0", marginBottom: "0.75rem" }}>🏦 SEPA-Lastschrift Konfiguration</h4>
          <p style={{ color: "#888", fontSize: "0.85rem", marginBottom: "1rem" }}>
            Diese Daten werden für den PAIN.008-Export verwendet. Gläubiger-ID erhältst du von deiner Bank.
          </p>

          <div className="form-group">
            <label>IBAN des Hofes</label>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <input type="text" placeholder="DE12 3456 7890 1234 5678 90"
                value={sepaHofIban} onChange={e => { setSepaHofIban(e.target.value); setSepaMsg(null); }}
                style={{ flex: 1, fontFamily: "monospace" }} />
            </div>
          </div>
          <div className="form-group">
            <label>BIC / SWIFT-Code der Bank</label>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <input type="text" placeholder="DEUTDEDB"
                value={sepaHofBic} onChange={e => { setSepaHofBic(e.target.value); setSepaMsg(null); }}
                style={{ flex: 1, fontFamily: "monospace" }} />
            </div>
          </div>
          <div className="form-group">
            <label>SEPA Gläubiger-ID (Creditor ID)</label>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <input type="text" placeholder="DE98ZZZ09999999999"
                value={sepaGlaeubigerID} onChange={e => { setSepaGlaeubigerID(e.target.value); setSepaMsg(null); }}
                style={{ flex: 1, fontFamily: "monospace" }} />
            </div>
          </div>
          <button className="btn btn-success" style={{ whiteSpace: "nowrap" }}
            onClick={async () => {
              await Promise.all([
                api.einstellungen.update("SepaHofIban", sepaHofIban),
                api.einstellungen.update("SepaHofBic", sepaHofBic),
                api.einstellungen.update("SepaGlaeubigerID", sepaGlaeubigerID),
              ]);
              setSepaMsg("✓ Gespeichert!");
              setTimeout(() => setSepaMsg(null), 3000);
            }}>💾 SEPA-Daten speichern</button>
          {sepaMsg && <div style={{ color: "#2e7d32", marginTop: "0.5rem", fontSize: "0.9rem" }}>{sepaMsg}</div>}
        </div>
      )}

      {/* ── Benutzerverwaltung (Rollen) ── */}
      {tab === "einstellungen" && <BenutzerverwaltungSection />}

      {/* ── News ── */}
      {tab === "news" && (
        <NewsTab news={news} setNews={setNews} />
      )}

    </div>
  );
}
